import React from 'react';

export const EndOfLifeIcon = () => (
  <svg
    width="167"
    height="121"
    viewBox="0 0 167 121"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 1331">
      <g id="Group 1329">
        <path
          id="path1424"
          d="M145.874 60.9386C145.874 94.0411 119.041 120.875 85.9372 120.875C52.8334 120.875 26 94.0411 26 60.9386C26 27.8364 52.8334 1.00051 85.9372 1.00051C119.041 1.00051 145.874 27.8364 145.874 60.9386Z"
          fill="#B3D4F3"
        />
        <g id="Group 1328">
          <path
            id="path1286"
            d="M13 109.996L3.06001e-07 109.996"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1290"
            d="M167 109.996L24 109.996"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1294"
            d="M112.838 86.0781H39.6505V40.0848H112.838V86.0781Z"
            fill="#46887C"
          />
          <path
            id="path1298"
            d="M39.7969 40.0858H27.8043L12.9993 77.1048V93.6133H31.0826L39.7969 86.0793V40.0858Z"
            fill="#B4DBAD"
          />
          <path
            id="path1302"
            d="M112.211 86.0781H39.0238V40.0849H112.211V86.0781Z"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1306"
            d="M33.1813 91.135L39.0234 86.0798V40.0867H27.0385L12.2298 77.1055V93.6133H26.3367"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1310"
            d="M30.9609 40.0825L16.156 77.1016H8.68642"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <g id="Clip path group">
            <mask
              id="mask0_1538_3794"
              maskUnits="userSpaceOnUse"
              x="67"
              y="36"
              width="5"
              height="49"
            >
              <g id="clipPath1318">
                <path
                  id="path1316"
                  d="M71.8926 84.1562H67.8318V36.998H71.8926V84.1562Z"
                  fill="white"
                />
              </g>
            </mask>
            <g mask="url(#mask0_1538_3794)">
              <g id="g1314">
                <g id="g1320">
                  <path
                    id="path1328"
                    d="M71.8984 84.1562H67.8362V36.9978H71.8984V84.1562Z"
                    fill="#316F63"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Clip path group_2">
            <mask
              id="mask1_1538_3794"
              maskUnits="userSpaceOnUse"
              x="90"
              y="36"
              width="5"
              height="49"
            >
              <g id="clipPath1336">
                <path
                  id="path1334"
                  d="M94.8965 84.1562H90.8357V36.998H94.8965V84.1562Z"
                  fill="white"
                />
              </g>
            </mask>
            <g mask="url(#mask1_1538_3794)">
              <g id="g1332">
                <g id="g1338">
                  <path
                    id="path1346"
                    d="M94.8945 84.1562H90.8351V36.9978H94.8945V84.1562Z"
                    fill="#316F63"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Clip path group_3">
            <mask
              id="mask2_1538_3794"
              maskUnits="userSpaceOnUse"
              x="56"
              y="36"
              width="5"
              height="49"
            >
              <g id="clipPath1354">
                <path
                  id="path1352"
                  d="M60.3965 84.1562H56.3357V36.998H60.3965V84.1562Z"
                  fill="white"
                />
              </g>
            </mask>
            <g mask="url(#mask2_1538_3794)">
              <g id="g1350">
                <g id="g1356">
                  <path
                    id="path1364"
                    d="M60.3984 84.1562H56.3397V36.9984H60.3984V84.1562Z"
                    fill="#316F63"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Clip path group_4">
            <mask
              id="mask3_1538_3794"
              maskUnits="userSpaceOnUse"
              x="79"
              y="36"
              width="5"
              height="49"
            >
              <g id="clipPath1372">
                <path
                  id="path1370"
                  d="M83.3984 84.1562H79.3376V36.998H83.3984V84.1562Z"
                  fill="white"
                />
              </g>
            </mask>
            <g mask="url(#mask3_1538_3794)">
              <g id="g1368">
                <g id="g1374">
                  <path
                    id="path1382"
                    d="M83.3984 84.1562H79.3394V36.9982H83.3984V84.1562Z"
                    fill="#316F63"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Clip path group_5">
            <mask
              id="mask4_1538_3794"
              maskUnits="userSpaceOnUse"
              x="44"
              y="36"
              width="5"
              height="49"
            >
              <g id="clipPath1390">
                <path
                  id="path1388"
                  d="M48.8945 84.1562H44.8337V36.998H48.8945V84.1562Z"
                  fill="white"
                />
              </g>
            </mask>
            <g mask="url(#mask4_1538_3794)">
              <g id="g1386">
                <g id="g1392">
                  <path
                    id="path1400"
                    d="M48.8906 84.1602H44.8315V37.0017H48.8906V84.1602Z"
                    fill="#316F63"
                  />
                </g>
              </g>
            </g>
          </g>
          <g id="Clip path group_6">
            <mask
              id="mask5_1538_3794"
              maskUnits="userSpaceOnUse"
              x="102"
              y="36"
              width="5"
              height="49"
            >
              <g id="clipPath1408">
                <path
                  id="path1406"
                  d="M106.4 84.1562H102.336V36.998H106.4V84.1562Z"
                  fill="white"
                />
              </g>
            </mask>
            <g mask="url(#mask5_1538_3794)">
              <g id="g1404">
                <g id="g1410">
                  <path
                    id="path1418"
                    d="M106.404 84.1562H102.341V36.9981H106.404V84.1562Z"
                    fill="#316F63"
                  />
                </g>
              </g>
            </g>
          </g>
          <path
            id="path1422"
            d="M119.999 45.9165H148.959L156.057 66.8808V91.1328H119.999V45.9165Z"
            fill="#B4DBAD"
          />
          <path
            id="path1426"
            d="M150.567 82.9375H155.08V72.4206H150.567V82.9375Z"
            fill="#FFBA52"
          />
          <path
            id="path1430"
            d="M132.183 49.1263H150.045L156.057 66.8828H132.183V49.1263Z"
            fill="#A2C4E2"
          />
          <path
            id="path1434"
            d="M128.047 66.8828H124.31V49.1263H128.047V66.8828Z"
            fill="#A2C4E2"
          />
          <path
            id="path1438"
            d="M119.023 91.1328V45.9159H147.981L155.082 66.8804V91.1328"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1442"
            d="M150.567 82.9375H155.08V72.4206H150.567V82.9375Z"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1446"
            d="M155.081 94.0391H159.318V74.2835"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1450"
            d="M131.206 49.1264H149.068L155.078 66.8828H131.206V49.1264Z"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1454"
            d="M127.074 66.8867H123.34V49.1301H127.074V66.8867Z"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1458"
            d="M131.206 74.2852H136.021"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1462"
            d="M141.82 98.0156C141.82 89.8687 135.215 83.2639 127.069 83.2639C118.917 83.2639 112.312 89.8687 112.312 98.0156"
            fill="#C8C8C8"
          />
          <path
            id="path1466"
            d="M98.1543 98.0156C98.1543 89.8686 91.547 83.264 83.399 83.264C75.2561 83.264 68.6489 89.8686 68.6489 98.0156"
            fill="#C8C8C8"
          />
          <path
            id="path1470"
            d="M66.5762 98.0156C66.5762 89.8687 59.9731 83.264 51.8261 83.264C43.6792 83.264 37.0707 89.8687 37.0707 98.0156"
            fill="#C8C8C8"
          />
          <path
            id="path1474"
            d="M155.746 91.1311H26.9995V98.0156H155.746V91.1311Z"
            fill="#D8DDDC"
          />
          <path
            id="path1478"
            d="M138.842 98.0194C138.842 91.7816 133.783 86.7225 127.545 86.7225C121.307 86.7225 116.248 91.7816 116.248 98.0194C116.248 104.261 121.307 109.316 127.545 109.316C133.783 109.316 138.842 104.261 138.842 98.0194Z"
            fill="#A9A9A9"
          />
          <path
            id="path1482"
            d="M133.207 98.0174C133.207 95.2666 130.98 93.0386 128.227 93.0386C125.478 93.0386 123.247 95.2666 123.247 98.0174C123.247 100.768 125.478 103 128.227 103C130.98 103 133.207 100.768 133.207 98.0174Z"
            fill="#F6F5F3"
          />
          <path
            id="path1486"
            d="M63.5957 98.0155C63.5957 91.7776 58.534 86.7186 52.2955 86.7186C46.0571 86.7186 41.0007 91.7776 41.0007 98.0155C41.0007 104.257 46.0571 109.312 52.2955 109.312C58.534 109.312 63.5957 104.257 63.5957 98.0155Z"
            fill="#A9A9A9"
          />
          <path
            id="path1490"
            d="M57.959 98.0175C57.959 95.2669 55.7345 93.0386 52.9818 93.0386C50.2291 93.0386 47.9992 95.2669 47.9992 98.0175C47.9992 100.769 50.2291 103 52.9818 103C55.7345 103 57.959 100.769 57.959 98.0175Z"
            fill="#F6F5F3"
          />
          <path
            id="path1494"
            d="M95.1641 98.0156C95.1641 91.7777 90.1035 86.7187 83.8671 86.7187C77.6308 86.7187 72.5703 91.7777 72.5703 98.0156C72.5703 104.258 77.6308 109.312 83.8671 109.312C90.1035 109.312 95.1641 104.258 95.1641 98.0156Z"
            fill="#A9A9A9"
          />
          <path
            id="path1498"
            d="M89.5371 98.0174C89.5371 95.267 87.306 93.0389 84.5556 93.0389C81.8052 93.0389 79.574 95.267 79.574 98.0174C79.574 100.768 81.8052 103 84.5556 103C87.306 103 89.5371 100.768 89.5371 98.0174Z"
            fill="#F6F5F3"
          />
          <path
            id="path1502"
            d="M38.7012 91.1315H26.3321V98.0156H38"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1506"
            d="M71 90.9961H65"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1510"
            d="M114.021 91.1328H96.4487"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1514"
            d="M141 98.0156H155.082V91.1312H143.92"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1518"
            d="M98.143 98.0156H112.316"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1522"
            d="M66 97.9961L69 97.9961"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1526"
            d="M138.365 98.0151C138.365 91.7771 133.308 86.7182 127.071 86.7182C120.83 86.7182 115.772 91.7771 115.772 98.0151C115.772 104.257 120.83 109.312 127.071 109.312C133.308 109.312 138.365 104.257 138.365 98.0151Z"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1530"
            d="M132.055 98.0171C132.055 95.2665 129.827 93.0387 127.076 93.0387C124.325 93.0387 122.093 95.2665 122.093 98.0171C122.093 100.768 124.325 103 127.076 103C129.827 103 132.055 100.768 132.055 98.0171Z"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1534"
            d="M141.82 98.0156C141.82 89.8687 135.215 83.2639 127.069 83.2639C118.917 83.2639 112.312 89.8687 112.312 98.0156"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1538"
            d="M159.318 82.9414H155.081"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1542"
            d="M63.1172 98.0156C63.1172 91.7772 58.0615 86.7188 51.8241 86.7188C45.5868 86.7188 40.5256 91.7772 40.5256 98.0156C40.5256 104.257 45.5868 109.312 51.8241 109.312C58.0615 109.312 63.1172 104.257 63.1172 98.0156Z"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1546"
            d="M56.8086 98.0176C56.8086 95.2668 54.5801 93.0383 51.8267 93.0383C49.0786 93.0383 46.8448 95.2668 46.8448 98.0176C46.8448 100.768 49.0786 103 51.8267 103C54.5801 103 56.8086 100.768 56.8086 98.0176Z"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1550"
            d="M66.5762 98.0156C66.5762 89.8687 59.9731 83.264 51.8261 83.264C43.6792 83.264 37.0707 89.8687 37.0707 98.0156"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1554"
            d="M94.6914 98.0155C94.6914 91.7773 89.6352 86.7184 83.398 86.7184C77.1557 86.7184 72.0994 91.7773 72.0994 98.0155C72.0994 104.257 77.1557 109.312 83.398 109.312C89.6352 109.312 94.6914 104.257 94.6914 98.0155Z"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1558"
            d="M88.3789 98.0175C88.3789 95.2665 86.1484 93.0386 83.3964 93.0386C80.6444 93.0386 78.4139 95.2665 78.4139 98.0175C78.4139 100.768 80.6444 103 83.3964 103C86.1484 103 88.3789 100.768 88.3789 98.0175Z"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1562"
            d="M98.1543 98.0156C98.1543 89.8686 91.547 83.264 83.399 83.264C75.2561 83.264 68.6489 89.8686 68.6489 98.0156"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1614"
            d="M94.8945 43.4922V36.9997H90.8351V43.4922"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1618"
            d="M106.395 43.5V37.0077H102.331V43.5"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1622"
            d="M71.8984 43.5V37.0077H67.8362V43.5"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1626"
            d="M83.3926 43.5V37.0077H79.3336V43.5"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1630"
            d="M48.8926 43.4922V37.0003H44.8335V43.4922"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
          <path
            id="path1634"
            d="M60.3965 43.5V37.0081H56.3377V43.5"
            stroke="#4D4D4D"
            strokeWidth="2"
            strokeMiterlimit="10"
          />
        </g>
        <path
          id="path1700"
          d="M154.382 15.8926C149.002 17.3376 144.797 21.5345 143.345 26.9141C141.901 21.5322 137.702 17.3285 132.324 15.8768C137.704 14.4319 141.909 10.2327 143.361 4.85536C144.806 10.2349 149.004 14.4409 154.382 15.8926Z"
          stroke="#392403"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="path1702"
          d="M129.203 9.10333C125.739 10.0327 123.032 12.7372 122.097 16.1992C121.166 12.735 118.463 10.0282 115 9.09203C118.464 8.16264 121.172 5.46043 122.107 1.99616C123.037 5.46043 125.741 8.16943 129.203 9.10333Z"
          stroke="#392403"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g id="Group 1330">
        <path
          id="path1566"
          d="M90.3201 64.5775C90.4855 65.3823 90.3385 66.1055 89.8745 66.7872L89.8607 66.8157C89.7918 66.9448 89.6953 67.0808 89.5759 67.2195C89.5621 67.2356 89.5437 67.2545 89.5345 67.2733C89.4518 67.3523 89.3599 67.4373 89.2588 67.526C88.7259 68.0056 88.1287 68.2362 87.435 68.2233L85.1425 68.2266L81.4902 62.0048L87.0813 58.7149L90.0858 63.864C90.196 64.0946 90.2742 64.3344 90.3201 64.5775Z"
          fill="white"
        />
        <path
          id="path1570"
          d="M88.7166 68.6023L85.3617 74.0224C85.2746 74.1585 85.1417 74.3034 84.9629 74.4455C84.5917 74.736 84.2067 74.8749 83.7713 74.8749L79.9168 74.8593L79.8985 76.8008L77.0156 71.8885L79.7793 66.6608L79.7427 68.8516L87.4288 68.842C87.8871 68.8484 88.3179 68.7696 88.7166 68.6023Z"
          fill="white"
        />
        <path
          id="path1574"
          d="M85.8963 53.3406L83.1841 58.3508L77.285 58.6914L79.1752 57.5928L76.212 52.6621L76.2028 52.6813L75.1435 51.0521C74.9243 50.67 74.6412 50.3512 74.3125 50.0956L80.6592 50.1051L81.2802 50.2408C81.7094 50.4019 82.0198 50.6576 82.2344 51.0238L84.2252 54.335L85.8963 53.3406Z"
          fill="white"
        />
        <path
          id="path1578"
          d="M74.6186 51.3743L75.8663 53.2967L72.4114 59.6484L66.6953 56.5706L69.5511 51.3238C69.6862 51.1189 69.8574 50.9292 70.0376 50.759C70.5961 50.2504 71.2222 50.0013 71.9519 49.995C72.0781 49.995 72.2087 50.0108 72.3348 50.0297L72.7852 50.1022C73.1141 50.1558 73.4339 50.2599 73.7177 50.4369C74.087 50.6608 74.3843 50.9734 74.6186 51.3743Z"
          fill="white"
        />
        <path
          id="path1582"
          d="M74.5484 68.6907L74.6114 75.1844L68.9455 75.2347C68.6397 75.2536 68.289 75.197 67.9023 75.0612C67.1333 74.8022 66.5847 74.3192 66.225 73.5836L66.2115 73.5615C66.1351 73.4293 66.0676 73.2742 66.0092 73.1038C65.9642 72.9747 65.9282 72.8389 65.8968 72.6905C65.7574 71.9926 65.8563 71.3644 66.207 70.7677L67.3492 68.7568L74.5484 68.6907Z"
          fill="white"
        />
        <path
          id="path1586"
          d="M68.2085 59.8903L71.3602 64.8877L69.4755 63.7641L66.9102 68.2941L65.6791 70.4564C65.4463 70.8445 65.3076 71.2582 65.2494 71.6875L62.1918 66.0557C62.1157 65.9107 62.0619 65.7213 62.0261 65.497C61.9545 65.0426 62.0306 64.6384 62.2499 64.2628L64.1929 60.9227L62.5051 59.9409L68.2085 59.8903Z"
          fill="white"
        />
        <path
          id="path1590"
          d="M90.3201 64.5775C90.4855 65.3823 90.3385 66.1055 89.8745 66.7872L89.8607 66.8157C89.7918 66.9448 89.6953 67.0808 89.5759 67.2195C89.5621 67.2356 89.5437 67.2545 89.5345 67.2733C89.4518 67.3523 89.3599 67.4373 89.2588 67.526C88.7259 68.0056 88.1287 68.2362 87.435 68.2233L85.1425 68.2266L81.4902 62.0048L87.0813 58.7149L90.0858 63.864C90.196 64.0946 90.2742 64.3344 90.3201 64.5775Z"
          stroke="#392403"
          strokeMiterlimit="10"
        />
        <path
          id="path1594"
          d="M88.7166 68.6023L85.3617 74.0224C85.2746 74.1585 85.1417 74.3034 84.9629 74.4455C84.5917 74.736 84.2067 74.8749 83.7713 74.8749L79.9168 74.8593L79.8985 76.8008L77.0156 71.8885L79.7793 66.6608L79.7427 68.8516L87.4288 68.842C87.8871 68.8484 88.3179 68.7696 88.7166 68.6023Z"
          stroke="#392403"
          strokeMiterlimit="10"
        />
        <path
          id="path1598"
          d="M85.8963 53.3406L83.1841 58.3508L77.285 58.6914L79.1752 57.5928L76.212 52.6621L76.2028 52.6813L75.1435 51.0521C74.9243 50.67 74.6412 50.3512 74.3125 50.0956L80.6592 50.1051L81.2802 50.2408C81.7094 50.4019 82.0198 50.6576 82.2344 51.0238L84.2252 54.335L85.8963 53.3406Z"
          stroke="#392403"
          strokeMiterlimit="10"
        />
        <path
          id="path1602"
          d="M74.6186 51.3743L75.8663 53.2967L72.4114 59.6484L66.6953 56.5706L69.5511 51.3238C69.6862 51.1189 69.8574 50.9292 70.0376 50.759C70.5961 50.2504 71.2222 50.0013 71.9519 49.995C72.0781 49.995 72.2087 50.0108 72.3348 50.0297L72.7852 50.1022C73.1141 50.1558 73.4339 50.2599 73.7177 50.4369C74.087 50.6608 74.3843 50.9734 74.6186 51.3743Z"
          stroke="#392403"
          strokeMiterlimit="10"
        />
        <path
          id="path1606"
          d="M74.5484 68.6907L74.6114 75.1844L68.9455 75.2347C68.6397 75.2536 68.289 75.197 67.9023 75.0612C67.1333 74.8022 66.5847 74.3192 66.225 73.5836L66.2115 73.5615C66.1351 73.4293 66.0676 73.2742 66.0092 73.1038C65.9642 72.9747 65.9282 72.8389 65.8968 72.6905C65.7574 71.9926 65.8563 71.3644 66.207 70.7677L67.3492 68.7568L74.5484 68.6907Z"
          stroke="#392403"
          strokeMiterlimit="10"
        />
        <path
          id="path1610"
          d="M68.2085 59.8903L71.3602 64.8877L69.4755 63.7641L66.9102 68.2941L65.6791 70.4564C65.4463 70.8445 65.3076 71.2582 65.2494 71.6875L62.1918 66.0557C62.1157 65.9107 62.0619 65.7213 62.0261 65.497C61.9545 65.0426 62.0306 64.6384 62.2499 64.2628L64.1929 60.9227L62.5051 59.9409L68.2085 59.8903Z"
          stroke="#392403"
          strokeMiterlimit="10"
        />
      </g>
    </g>
  </svg>
);

export const UseStageIcon = () => (
  <svg
    width="129"
    height="148"
    viewBox="0 0 129 148"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 1326">
      <path
        id="path1420"
        d="M127.005 138.496H114.129"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1424"
        d="M127.005 88.0636C127.005 121.166 100.172 148 67.0681 148C33.9643 148 7.13086 121.166 7.13086 88.0636C7.13086 54.9614 33.9643 28.1255 67.0681 28.1255C100.172 28.1255 127.005 54.9614 127.005 88.0636Z"
        fill="#C5ECBE"
      />
      <g id="Clip path group">
        <mask
          id="mask0_1538_4514"
          maskUnits="userSpaceOnUse"
          x="22"
          y="8"
          width="64"
          height="80"
        >
          <g id="clipPath1432">
            <path
              id="path1430"
              d="M70.8945 84.9813C70.6272 85.1884 70.3411 85.3766 70.0343 85.5404C68.0616 86.5964 65.7464 86.4458 63.9638 85.3145C63.2636 84.8722 62.6481 84.2774 62.1662 83.5433L46.5393 59.8187L33.0921 40.365L22.0938 32.5967L37.7094 8.11167L49.4117 14.5981L72.8445 19.5429C75.4383 20.0907 77.6162 21.7283 78.8811 23.9626C79.3084 24.7211 79.6321 25.5494 79.8317 26.4265L84.6654 47.7644L85.8663 53.063C86.0395 53.8235 86.0226 54.616 85.8174 55.3689L77.6218 85.3672C77.2604 86.6905 75.9033 87.4773 74.5762 87.1347C73.7913 86.9314 73.0384 86.5888 72.3589 86.1578C71.8149 85.8133 71.3199 85.4124 70.8945 84.9813ZM70.1378 72.129L72.948 57.9589L69.0686 46.1926L60.4721 43.2562L60.4138 47.1338C60.3818 49.338 60.8354 51.5196 61.7408 53.528L70.1378 72.129Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask0_1538_4514)">
          <g id="g1428">
            <g id="g1434">
              <path
                id="path1442"
                d="M70.8926 84.9814C70.6249 85.1884 70.3396 85.3767 70.0323 85.5404C68.0593 86.5963 65.7439 86.4459 63.9618 85.3146C63.2617 84.8721 62.6472 84.2774 62.1644 83.5433L46.5383 59.8188L33.0915 40.365L22.0918 32.5967L37.7069 8.11176L49.4089 14.5982L72.8437 19.543C75.4356 20.0908 77.6149 21.7282 78.8791 23.9626C79.307 24.7211 79.6296 25.5494 79.8293 26.4266L84.6642 47.7645L85.8647 53.0631C86.0381 53.8236 86.0205 54.6161 85.8164 55.3689L77.6193 85.3672C77.2594 86.6904 75.9009 87.4774 74.5753 87.1346C73.7896 86.9314 73.0368 86.5888 72.3565 86.1578C71.8122 85.8134 71.3184 85.4125 70.8926 84.9814ZM70.1355 72.129L72.9468 57.959L69.0666 46.1927L60.4701 43.2562L60.413 47.1338C60.3801 49.3379 60.8344 51.5196 61.7386 53.528L70.1355 72.129Z"
                fill="#FFE3B9"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Clip path group_2">
        <mask
          id="mask1_1538_4514"
          maskUnits="userSpaceOnUse"
          x="95"
          y="37"
          width="31"
          height="32"
        >
          <g id="clipPath1450">
            <path
              id="path1448"
              d="M124.831 64.3395C125.539 65.1451 125.413 66.3837 124.56 67.0331C121.863 69.0848 118.23 69.1752 115.469 67.4227C114.989 67.1178 114.535 66.7583 114.117 66.3423L111.375 63.6129L107.617 48.9178C107.29 47.6378 106.571 46.4934 105.56 45.6407L95.373 37.2983L100.51 38.4258C101.795 38.7251 102.957 39.4215 103.826 40.4154L124.831 64.3395Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask1_1538_4514)">
          <g id="g1446">
            <g id="g1452">
              <path
                id="path1460"
                d="M124.831 64.3394C125.537 65.1451 125.41 66.3837 124.558 67.033C121.862 69.0848 118.228 69.1752 115.468 67.4227C114.988 67.1178 114.533 66.7583 114.116 66.3422L111.374 63.6128L107.615 48.9178C107.289 47.6376 106.57 46.4933 105.56 45.6406L95.3711 37.2981L100.508 38.4256C101.794 38.725 102.956 39.4213 103.825 40.4153L124.831 64.3394Z"
                fill="#FFE3B9"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Clip path group_3">
        <mask
          id="mask2_1538_4514"
          maskUnits="userSpaceOnUse"
          x="78"
          y="23"
          width="38"
          height="60"
        >
          <g id="clipPath1468">
            <path
              id="path1466"
              d="M115.505 79.7588C115.77 80.7997 115.098 81.8462 114.042 82.0382C112.004 82.4091 109.986 81.9686 108.343 80.9258C106.833 79.9677 105.642 78.5014 105.045 76.6906L98.4023 56.4972L84.669 47.7595H84.6671L79.8334 26.4217C79.6339 25.5445 79.3101 24.7163 78.8828 23.9578L79.0052 23.8881L95.3737 37.2958L105.561 45.6382C106.572 46.4909 107.291 47.6353 107.618 48.9153L111.375 63.6104L115.505 79.7588Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask2_1538_4514)">
          <g id="g1464">
            <g id="g1470">
              <path
                id="path1478"
                d="M115.503 79.7589C115.769 80.7996 115.097 81.8463 114.042 82.0383C112.003 82.409 109.986 81.9687 108.342 80.9258C106.833 79.9678 105.64 78.5015 105.044 76.6907L98.4024 56.4972L84.6686 47.7596H84.6662L79.8332 26.4218C79.6337 25.5445 79.3081 24.7162 78.8828 23.9578L79.004 23.8882L95.3729 37.2957L105.559 45.6382C106.571 46.491 107.289 47.6353 107.617 48.9153L111.374 63.6105L115.503 79.7589Z"
                fill="#FFE3B9"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="path1482"
        d="M72.0545 71.9688L74.8864 57.8242L70.9791 46.0825L62.3164 43.1498"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1486"
        d="M39.6289 8.19811L51.296 14.6843L74.661 19.6288C78.1239 20.3628 80.8454 23.0506 81.6265 26.5121L87.6459 53.1488C87.8175 53.9092 87.7999 54.7 87.5931 55.4528L79.4242 85.4494C79.0634 86.7726 77.7103 87.5592 76.3859 87.2168C74.9778 86.8536 73.6731 86.0348 72.7161 85.0635"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1490"
        d="M81.0176 23.8349L107.518 45.5741C108.526 46.4263 109.244 47.5703 109.573 48.8495L117.443 79.6775C117.708 80.7179 117.038 81.7639 115.984 81.9559C112.079 82.6689 108.247 80.3886 107.005 76.6109L100.377 56.4297L86.6681 47.6942"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1494"
        d="M97.2676 37.3221L102.427 38.4464C103.719 38.7467 104.884 39.4392 105.76 40.4303L126.851 64.2852C127.562 65.0903 127.437 66.3234 126.578 66.9727C123.399 69.3732 118.922 69.0785 116.092 66.2821L113.337 63.5607"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="Clip path group_4">
        <mask
          id="mask3_1538_4514"
          maskUnits="userSpaceOnUse"
          x="44"
          y="71"
          width="70"
          height="29"
        >
          <g id="clipPath1502">
            <path
              id="path1500"
              d="M113.356 99.9492H68.2827L44.543 71.0972H107.011L113.356 99.9492Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask3_1538_4514)">
          <g id="g1498">
            <g id="g1504">
              <path
                id="path1512"
                d="M113.358 99.9492H68.2835L44.5449 71.0974H107.012L113.358 99.9492Z"
                fill="#7091B0"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="path1516"
        d="M102.172 71.0483L108.61 99.8672"
        stroke="#B3D4F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1520"
        d="M97.2676 71.0483L103.706 99.8672"
        stroke="#B3D4F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1524"
        d="M92.3613 71.0483L98.7996 99.8672"
        stroke="#B3D4F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1528"
        d="M87.457 71.0483L93.8953 99.8672"
        stroke="#B3D4F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1532"
        d="M82.5508 71.0483L88.9891 99.8672"
        stroke="#B3D4F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1536"
        d="M77.6465 71.0483L84.0848 99.8672"
        stroke="#B3D4F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1540"
        d="M72.7402 71.0483L79.1785 99.8672"
        stroke="#B3D4F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1544"
        d="M67.8359 71.0483L74.2742 99.8672"
        stroke="#B3D4F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1548"
        d="M62.9297 71.0483L69.368 99.8672"
        stroke="#B3D4F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1552"
        d="M58.0254 71.0483L64.4637 99.8672"
        stroke="#B3D4F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1556"
        d="M53.1191 71.0483L59.5574 99.8672"
        stroke="#B3D4F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1560"
        d="M48.2148 71.0483L54.6531 99.8672"
        stroke="#B3D4F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1564"
        d="M19.3945 131.751V138.496H66.9151V131.751H19.3945Z"
        fill="#7091B0"
      />
      <path
        id="path1568"
        d="M66.9151 99.8632L43.1548 71.0463L19.3945 99.8632V131.75H66.9151V99.8632Z"
        fill="#B3D4F3"
      />
      <path
        id="path1572"
        d="M106.465 99.8652H66.3027V131.75H106.465V99.8652Z"
        fill="#B3D4F3"
      />
      <path
        id="path1576"
        d="M66.3027 131.751V138.496H106.465V131.751H66.3027Z"
        fill="#7091B0"
      />
      <path
        id="path1580"
        d="M49.1344 127.152H36.2578V114.276H49.1344V127.152Z"
        fill="#C9ECF6"
      />
      <path
        id="path1584"
        d="M49.1344 99.2539H36.2578V92.8156C36.2578 89.2594 39.14 86.3774 42.6971 86.3774C46.2522 86.3774 49.1344 89.2594 49.1344 92.8156V99.2539Z"
        fill="#FFF299"
      />
      <g id="Clip path group_5">
        <mask
          id="mask4_1538_4514"
          maskUnits="userSpaceOnUse"
          x="72"
          y="114"
          width="29"
          height="25"
        >
          <g id="clipPath1592">
            <path
              id="path1590"
              d="M100.93 138.555H72.5918V114.256H100.93V138.555Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask4_1538_4514)">
          <g id="g1588">
            <g id="g1594">
              <path
                id="path1602"
                d="M100.926 138.555H72.5879V114.256H100.926V138.555Z"
                fill="#C9ECF6"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="path1606"
        d="M52.7211 138.496H68.1417V99.8977L44.5358 71.0475L20.9277 99.8977V138.496"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1610"
        d="M29.8184 138.496H47.9068"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1614"
        d="M113.21 99.8672H68.2261L44.5352 71.0483H106.877L113.21 99.8672Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1618"
        d="M69.9191 138.496H108.305V99.8665H68.1426V138.496"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1622"
        d="M50.9742 127.152H38.0977V114.276H50.9742V127.152Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1626"
        d="M50.9742 99.2539H38.0977V92.8156C38.0977 89.2594 40.9808 86.3774 44.5369 86.3774C48.093 86.3774 50.9742 89.2594 50.9742 92.8156V99.2539Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1630"
        d="M102.479 138.496H74.2734V114.276H102.479V138.496Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="Clip path group_6">
        <mask
          id="mask5_1538_4514"
          maskUnits="userSpaceOnUse"
          x="34"
          y="38"
          width="42"
          height="49"
        >
          <g id="clipPath1638">
            <path
              id="path1636"
              d="M74.5338 77.6284L63.6409 53.4991C62.7355 51.4907 62.2819 49.3072 62.3158 47.1049L62.4475 38.2505L34.9922 40.3342L48.4413 59.7897L64.0663 83.5144C65.7792 86.1138 69.19 86.9778 71.9344 85.5096C72.3372 85.2931 72.7042 85.039 73.0355 84.751C75.0364 83.0212 75.7103 80.1168 74.5338 77.6284Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask5_1538_4514)">
          <g id="g1634">
            <g id="g1640">
              <path
                id="path1648"
                d="M74.5353 77.6283L63.6425 53.4991C62.736 51.4908 62.2827 49.3073 62.3168 47.1049L62.4487 38.2506L34.9941 40.3342L48.4427 59.7899L64.068 83.5144C65.781 86.1139 69.1921 86.9778 71.935 85.5095C72.3393 85.2931 72.7053 85.0391 73.0373 84.7512C75.0375 83.0212 75.7121 80.1167 74.5353 77.6283Z"
                fill="#FFE3B9"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="path1652"
        d="M62.5079 38.1328L62.3756 47.037C62.3414 49.2517 62.7962 51.4473 63.7036 53.4672L74.6136 77.7323C75.7921 80.2347 75.1174 83.1555 73.1126 84.8969C72.7817 85.1846 72.4145 85.4403 72.011 85.6579C69.261 87.1344 65.845 86.2656 64.1284 83.6515L48.4787 59.7933L35.0066 40.2281L23.9941 32.4162"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1656"
        d="M28.7531 41.0039L17.248 33.6908L36.7061 2.98745L48.2131 10.3006L28.7531 41.0039Z"
        fill="#B3D4F3"
      />
      <path
        id="path1660"
        d="M17.248 33.6646L36.7061 2.98454L48.2131 10.2921L36.0572 29.4581C32.0229 35.8159 23.6034 37.7002 17.248 33.6646Z"
        fill="#C9ECF6"
      />
      <path
        id="path1664"
        d="M28.7531 41.0039L17.248 33.6908L36.708 2.98745L48.2131 10.3006L28.7531 41.0039Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1668"
        d="M39.323 -1.00073L14.7987 37.6289L1 28.8719"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1672"
        d="M17.248 33.6646L36.708 2.98453L48.2131 10.2921L36.0572 29.4581C32.0229 35.8159 23.6034 37.7002 17.248 33.6646Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1676"
        d="M109.223 138.496H7.13086"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1680"
        d="M39.3229 66.1488C34.9089 67.3539 31.4616 70.8555 30.2711 75.3398C29.0863 70.8536 25.6427 67.3462 21.2344 66.1356C25.6446 64.9307 29.0938 61.4308 30.2843 56.9448C31.4691 61.4327 34.9108 64.9382 39.3229 66.1488Z"
        fill="white"
      />
      <path
        id="path1682"
        d="M18.4744 60.3183V60.3202C15.558 61.0825 13.2774 63.299 12.4912 66.1406C11.7088 63.299 9.43206 61.0769 6.51758 60.3109C9.43396 59.5486 11.7126 57.3302 12.4988 54.4904C13.2831 57.332 15.558 59.5523 18.4744 60.3183Z"
        fill="white"
      />
      <path
        id="path1686"
        d="M41.4693 66.1489C36.9802 67.3537 33.4763 70.8536 32.264 75.3398C31.0595 70.8519 27.5575 67.3462 23.0742 66.1358C27.5595 64.9307 31.0672 61.4289 32.2775 56.9448C33.482 61.4308 36.9821 64.9382 41.4693 66.1489Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1688"
        d="M20.3143 60.3192C17.4727 61.0833 15.2506 63.2995 14.4845 66.1406C13.7222 63.2995 11.5038 61.0777 8.66406 60.3118C11.5057 59.5477 13.7259 57.3316 14.492 54.4904C15.2561 57.3316 17.4727 59.5533 20.3143 60.3192Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const DistributionIcon = () => (
  <svg
    width="143"
    height="148"
    viewBox="0 0 143 148"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 1327">
      <path
        id="path1108"
        d="M141.781 78.0079C141.781 116.664 110.445 148 71.7858 148C33.135 148 1.79492 116.664 1.79492 78.0079C1.79492 39.352 33.135 8.01405 71.7858 8.01405C110.445 8.01405 141.781 39.352 141.781 78.0079Z"
        fill="#FFF299"
      />
      <path
        id="path1112"
        d="M121.863 137.059H1.79492"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1116"
        d="M141.781 137.059H128.596"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1120"
        d="M90.8864 51.9414C79.2764 63.8274 60.1852 64.0975 48.2436 52.5407C36.298 40.9863 36.0311 21.9819 47.6371 10.0959C59.2471 -1.79221 78.3423 -2.06025 90.2839 9.49454C102.225 21.0509 102.496 40.0557 90.8864 51.9414Z"
        fill="white"
      />
      <g id="Clip path group">
        <mask
          id="mask0_1538_111"
          maskUnits="userSpaceOnUse"
          x="37"
          y="1"
          width="61"
          height="61"
        >
          <g id="clipPath1128">
            <path
              id="path1126"
              d="M97.7268 31.0682C97.7268 47.6735 84.2658 61.1367 67.6583 61.1367C51.053 61.1367 37.5898 47.6735 37.5898 31.0682C37.5898 14.4608 51.053 0.999756 67.6583 0.999756C84.2658 0.999756 97.7268 14.4608 97.7268 31.0682Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask0_1538_111)">
          <g id="g1124">
            <g id="g1130">
              <path
                id="path1132"
                d="M73.7454 5.57511L74.1603 5.65228C74.2146 5.66314 74.2456 5.71353 74.2301 5.76433L74.1874 5.91364C74.1758 5.95125 74.1913 5.99273 74.2262 6.01251L74.5519 6.21956C74.5674 6.22809 74.5791 6.23236 74.5946 6.23236L74.7031 6.23702C74.7574 6.23934 74.8001 6.28976 74.7885 6.34482L74.7574 6.46346C74.7574 6.47238 74.7574 6.48324 74.7574 6.49216L74.7768 6.69884C74.7807 6.74265 74.8156 6.77793 74.8621 6.77987L75.1142 6.79305C75.1219 6.79305 75.1297 6.79538 75.1374 6.7977L75.5368 6.92956C75.6066 6.9536 75.6182 7.04623 75.5562 7.08772L75.3429 7.2351C75.308 7.25953 75.2964 7.30332 75.3119 7.34287L75.3701 7.47472C75.374 7.49256 75.3895 7.50766 75.4089 7.51891L75.7035 7.67287C75.7501 7.69459 75.7656 7.74965 75.7423 7.79386L75.6919 7.88614C75.6686 7.92802 75.6841 7.97842 75.7229 8.00246C75.7578 8.02457 75.8044 8.01794 75.8315 7.98925L75.9711 7.8485C75.9866 7.83532 76.0021 7.82678 76.0215 7.82445L76.4868 7.76088C76.4946 7.75855 76.5062 7.75854 76.5178 7.76281L76.7427 7.81556C76.7505 7.81788 76.7621 7.81787 76.7699 7.81787L77.1033 7.78261C77.1421 7.77835 77.1731 7.75195 77.1809 7.71434L77.2662 7.35839C77.2701 7.33435 77.2662 7.30797 77.2507 7.28781L77.0917 7.06603C77.0723 7.04392 77.0452 7.03073 77.018 7.03073H76.5411C76.5101 7.03073 76.4829 7.01328 76.4674 6.98885L76.068 6.33823C76.0525 6.31613 76.0293 6.30062 76.0021 6.29635C75.8742 6.28084 75.4864 6.23468 75.4476 6.25019C75.4166 6.26338 75.2305 6.18428 75.1452 6.14667C75.1142 6.13348 75.0948 6.10944 75.0909 6.07881L75.0289 5.65887C75.025 5.61893 74.994 5.58831 74.9552 5.58405L74.5558 5.5313C74.5093 5.52665 74.4744 5.48944 74.4744 5.4433V5.28702C74.4744 5.22576 74.4162 5.18386 74.3581 5.20364L74.075 5.30255C74.0595 5.30681 74.0362 5.30681 74.0168 5.30255L73.8307 5.23662C73.7842 5.22111 73.7299 5.24979 73.7183 5.3002L73.6756 5.46537C73.6601 5.51578 73.695 5.56425 73.7454 5.57511Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1134">
              <path
                id="path1136"
                d="M73.9316 7.37608C73.9007 7.40274 73.8929 7.44637 73.9084 7.48152L73.9393 7.54527C73.9586 7.58081 73.9972 7.60051 74.0359 7.59163L74.793 7.44444C74.8354 7.43555 74.8664 7.39383 74.8625 7.34979L74.8316 7.03111C74.8277 7.00446 74.8161 6.98246 74.793 6.9674L74.4415 6.70783C74.4183 6.69238 74.4028 6.66801 74.4028 6.64174L74.3951 6.53167C74.3912 6.4745 74.3372 6.43742 74.2831 6.45249L74.1942 6.47912C74.1672 6.48569 74.144 6.50774 74.1363 6.53401L74.0745 6.72096C74.0668 6.74298 74.0513 6.76073 74.032 6.77154L73.8311 6.87275C73.7848 6.8967 73.7693 6.96044 73.8041 7.00448L73.8311 7.04194C73.8466 7.05971 73.8659 7.07286 73.8891 7.07479L74.0243 7.09913C74.0977 7.11226 74.1247 7.20455 74.0668 7.25322L73.9316 7.37608Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1138">
              <path
                id="path1140"
                d="M88.5899 11.092L88.5819 11.0988C88.5339 11.136 88.4738 11.1448 88.4218 11.1252L87.9535 10.9491C87.8975 10.9271 87.8294 10.9403 87.7854 10.9823L87.6093 11.1492C87.5693 11.1889 87.5133 11.202 87.4572 11.1888L86.9329 11.0592C86.9209 11.0548 86.9048 11.0524 86.8928 11.0524H86.5446C86.4726 11.0524 86.4085 11.0039 86.3885 10.9339L86.2324 10.3599C86.2284 10.3555 86.2284 10.3487 86.2244 10.3443L85.7641 9.55061C85.7401 9.51099 85.7601 9.46495 85.8041 9.45414L86.0923 9.37691C86.1123 9.37251 86.1324 9.37691 86.1484 9.39012L86.6207 9.76196C86.6607 9.79237 86.7167 9.77274 86.7247 9.72431L86.7848 9.49139C86.7928 9.44296 86.8528 9.42535 86.8889 9.45618L87.157 9.68269C87.157 9.68469 87.161 9.6871 87.161 9.68909L87.5293 10.1094C87.5413 10.1182 87.5493 10.1246 87.5613 10.129L88.2577 10.3443C88.2737 10.3487 88.2857 10.3599 88.2937 10.3707L88.6219 10.8786C88.666 10.9471 88.654 11.0415 88.5899 11.092ZM94.998 39.1905L95.3382 37.6183C95.3382 37.6139 95.3422 37.6095 95.3422 37.6051L96.0827 32.913C96.0827 32.9086 96.0867 32.9042 96.0867 32.8998C96.1227 32.7281 96.8391 29.432 96.8391 29.3815C96.8391 29.3287 97.0312 27.4003 97.0312 27.4003L97.6476 25.1204L97.2274 24.2959L96.3668 25.7689L95.6464 24.452L94.6818 22.7874L93.7012 21.0327L93.0007 19.3836L91.84 17.9103L91.5798 16.9629L91.6999 16.8068L92.4043 17.8579L93.5411 19.3836L94.4376 21.3141L95.4182 23.6119L95.6664 24.2079L96.0506 24.0494L96.543 23.1548L95.9466 20.5952L95.3502 17.508L93.9813 17.3852L93.7012 16.9209C93.6411 16.8244 93.7692 16.7211 93.8492 16.8L93.9093 16.8596L94.5217 16.6903C94.5697 16.6771 94.6017 16.6243 94.5897 16.5734L94.3175 15.492C94.3175 15.4788 94.3095 15.4675 94.3015 15.4567L93.1088 13.9022C93.1048 13.8978 93.1008 13.8934 93.0968 13.889L91.4717 12.3936C91.3437 12.2751 91.1435 12.418 91.2156 12.5785L91.2476 12.6578C91.2876 12.7522 91.1755 12.8355 91.0955 12.7718L90.7953 12.5301C90.7793 12.5169 90.7673 12.4993 90.7553 12.4796L90.315 11.668L89.9188 10.9095C89.9148 10.9007 89.9067 10.8919 89.9027 10.8831L87.4212 7.75666C87.4212 7.75666 84.8075 5.45883 84.7555 5.44122C84.7075 5.42561 81.5055 3.67973 80.9051 3.35232C80.845 3.3195 80.773 3.3127 80.7049 3.33231L79.5442 3.67331C79.5082 3.68211 79.4762 3.6845 79.4442 3.6821L79.188 3.6581C79.0559 3.64489 78.9478 3.5304 78.9478 3.39391C78.9478 3.30386 78.9038 3.21822 78.8277 3.16978L78.5436 2.99166C78.4515 2.93243 78.3394 2.91925 78.2354 2.95887L78.0152 3.03771C77.9392 3.06653 77.8551 3.06651 77.7791 3.0401L76.8625 2.71911C76.8505 2.71471 76.8385 2.71469 76.8265 2.71469L75.8859 2.79154L75.5617 2.83317C75.5097 2.83997 75.4736 2.89041 75.4856 2.94124L75.5497 3.207C75.5537 3.22901 75.5657 3.24664 75.5817 3.25984L76.002 3.56765C76.034 3.59207 76.046 3.63369 76.03 3.67131L75.8499 4.12641C75.8459 4.13081 75.8459 4.13719 75.8459 4.14399L75.7658 4.57907C75.7578 4.6187 75.7818 4.65832 75.8178 4.67593L76.2981 4.88728C76.3142 4.89368 76.3222 4.90488 76.3342 4.91769L76.6024 5.28952C76.6144 5.30914 76.6344 5.32034 76.6544 5.32474L77.1387 5.42801C77.1627 5.43441 77.1867 5.42801 77.2067 5.4148L77.5229 5.19267C77.551 5.17305 77.587 5.17064 77.615 5.18825L77.8872 5.33795C77.8952 5.34235 77.8992 5.34675 77.9072 5.35316L78.1633 5.61934C78.1794 5.63695 78.2034 5.64776 78.2274 5.64776H78.5396C78.5676 5.64776 78.5916 5.65895 78.6076 5.67856L78.9638 6.11164C78.9799 6.13366 78.9878 6.16249 78.9878 6.19091V6.28097C78.9878 6.35582 79.0559 6.41306 79.132 6.40425L79.3561 6.37142C79.4161 6.36461 79.4642 6.31176 79.4642 6.25052V5.99079C79.4642 5.97117 79.4602 5.95355 79.4522 5.93794L79.176 5.35116C79.176 5.34676 79.172 5.34235 79.172 5.33995L78.9238 4.92648C78.9078 4.90007 78.8798 4.88049 78.8478 4.87168L78.3274 4.7332C78.3154 4.72879 78.2994 4.71997 78.2914 4.70877L77.8271 4.24726C77.8231 4.24286 77.8151 4.23608 77.8111 4.22968L77.603 3.87785C77.587 3.85583 77.587 3.83181 77.591 3.8098L77.611 3.73053C77.631 3.66689 77.703 3.6425 77.7551 3.68452L78.0993 3.97029C78.1153 3.9835 78.1233 3.99871 78.1273 4.01872L78.1993 4.29769C78.2073 4.33291 78.2394 4.35934 78.2754 4.36374L78.5756 4.39454C78.5876 4.39655 78.6036 4.40095 78.6116 4.40776L79.1599 4.72636L79.6202 4.99054C79.6603 5.01456 79.7123 5.01254 79.7483 4.98812L80.0445 4.80121C80.0685 4.786 80.0965 4.77922 80.1206 4.78162L80.6089 4.81442C80.6489 4.81682 80.6849 4.83886 80.7049 4.87168C80.753 4.94653 80.7089 5.04538 80.6209 5.06059L80.2046 5.13345C80.1246 5.14666 80.0766 5.2347 80.1126 5.30914L80.2327 5.55527C80.2367 5.56448 80.2406 5.5709 80.2486 5.57971L80.5929 6.01279C80.5929 6.01519 80.5969 6.01717 80.5969 6.01717L80.869 6.32056C80.9211 6.3758 80.9131 6.46146 80.853 6.50549L80.785 6.55392C80.749 6.58233 80.7009 6.58675 80.6609 6.56673L80.5969 6.53832C80.5368 6.5119 80.4648 6.5363 80.4368 6.59554L80.3287 6.8133C80.3007 6.86813 80.2366 6.89455 80.1766 6.87494L79.7283 6.72523C79.7003 6.71643 79.6723 6.71641 79.6443 6.72762L79.22 6.87931C79.168 6.89693 79.1119 6.87933 79.0799 6.8353L78.9638 6.67481C78.9518 6.66601 78.9438 6.65479 78.9318 6.64839L78.5676 6.38424C78.5436 6.36703 78.5276 6.3406 78.5316 6.30978L78.5396 6.08084C78.5436 6.04802 78.5236 6.01717 78.4955 6.00196L78.0633 5.75341C78.0353 5.7358 77.9992 5.73779 77.9712 5.7554L77.8512 5.83467C77.8111 5.86349 77.8031 5.91593 77.8271 5.95795L77.9832 6.19971C77.9872 6.20851 77.9952 6.21531 78.0032 6.22171L78.3435 6.48348C78.3675 6.50309 78.3835 6.53392 78.3755 6.56673L78.3515 6.74286C78.3475 6.78009 78.3194 6.81087 78.2834 6.81768L77.9432 6.89695C77.9072 6.90535 77.8792 6.93217 77.8752 6.96699L77.8111 7.3144C77.8071 7.33201 77.8111 7.35405 77.8231 7.37166L77.8912 7.49931C77.9032 7.52573 77.9032 7.55655 77.8912 7.58257L77.7351 7.87315C77.7271 7.87955 77.7271 7.88635 77.7231 7.89476L77.663 8.16974C77.655 8.20936 77.619 8.23818 77.579 8.23818H77.1587C77.1427 8.23818 77.1267 8.2426 77.1147 8.24901L76.9025 8.35908C76.8905 8.36548 76.8785 8.36987 76.8625 8.36987H76.3302C76.2782 8.36987 76.2421 8.4095 76.2421 8.45793V8.54357C76.2421 8.58119 76.2661 8.61401 76.2981 8.62721L77.2748 8.96145L77.8992 9.73753L77.8191 10.0806L77.583 10.4216L76.1221 10.2895L75.5417 10.4216L75.5817 10.6457L75.8058 11.4218L75.8219 11.9077L75.7298 12.1587L76.2021 12.5125L76.2781 13.0532L76.6624 13.4207L77.1107 13.2117L77.543 13.3414L77.567 13.592H77.647L77.8311 13.2754L78.3034 13.2117L78.7517 13.315L79.4361 12.5785L79.3441 11.8024L79.3321 11.3689L79.8324 11.2637L79.5962 10.448L79.8324 10.3423L80.3967 10.4872L80.753 10.3952L81.1012 10.0345C81.1212 10.0145 81.1492 10.0081 81.1772 10.0189L81.6776 10.2346C81.6816 10.2366 81.6896 10.2411 81.6936 10.2455L82.0378 10.5512C82.0418 10.5532 82.0418 10.5533 82.0418 10.5557L82.426 10.9647C82.43 10.9711 82.442 10.9755 82.45 10.9799L83.7428 11.5363C83.7508 11.5383 83.7549 11.5407 83.7589 11.5451L84.1351 11.822C84.1431 11.8264 84.1511 11.8329 84.1551 11.8417L84.4793 12.4068C84.4873 12.4156 84.4873 12.4268 84.4873 12.4401V12.5849C84.4873 12.6137 84.5073 12.6378 84.5313 12.649C84.5634 12.6598 84.6034 12.6422 84.6154 12.6093L84.7875 12.1322C84.7995 12.1078 84.7955 12.0814 84.7755 12.0638L84.5554 11.8353C84.5194 11.7956 84.5434 11.7296 84.5994 11.7232L84.7635 11.7076C84.8115 11.7032 84.8395 11.6483 84.8115 11.6087L84.7755 11.5427C84.7675 11.5319 84.7595 11.5231 84.7475 11.5187L83.5427 10.9491L83.5387 10.9471L82.7943 10.4896C82.7943 10.4896 82.7903 10.4872 82.7863 10.4832L82.0898 9.87601C82.0858 9.87161 82.0778 9.86523 82.0778 9.85842L81.9457 9.62308C81.9337 9.59706 81.9377 9.56621 81.9577 9.5442L82.0017 9.50019C82.0178 9.48458 82.0418 9.47816 82.0618 9.48256L82.5461 9.58782C82.5581 9.59222 82.5741 9.59903 82.5821 9.60783L82.9824 10.0453C82.9864 10.0521 82.9904 10.0541 82.9984 10.0585L83.6148 10.4192C83.6188 10.4216 83.6228 10.4236 83.6228 10.4236L84.5233 10.771C84.5353 10.7754 84.5434 10.7822 84.5514 10.7886L84.8556 11.1316L85.4839 11.8372C85.4879 11.8417 85.488 11.8441 85.492 11.8461L85.8962 12.1607C85.9042 12.1671 85.9122 12.1759 85.9162 12.1871L86.2565 12.9368C86.2685 12.9676 86.2965 12.9896 86.3285 12.994L86.6007 13.0268C86.6527 13.0336 86.7007 12.994 86.7047 12.9412L86.7168 12.8599C86.7208 12.8007 86.7608 12.7478 86.8128 12.7258C86.9008 12.6882 86.9409 12.5873 86.8969 12.5037L86.8728 12.4508C86.8608 12.4312 86.8488 12.4136 86.8328 12.4004L86.2965 11.9409C86.2445 11.8969 86.2244 11.8265 86.2484 11.7648L86.3045 11.5979C86.3285 11.5319 86.3885 11.4879 86.4566 11.4879H86.5887C86.6487 11.4879 86.7007 11.5187 86.7288 11.5715L86.8528 11.7868C86.8728 11.822 86.9048 11.8505 86.9449 11.8617L87.0409 11.8925C87.097 11.9101 87.141 11.9561 87.153 12.0134L87.205 12.2551C87.209 12.2771 87.209 12.3016 87.205 12.3236L87.193 12.3716C87.173 12.4577 87.2291 12.5433 87.3131 12.5653L87.4732 12.6049C87.5052 12.6137 87.5413 12.6358 87.5613 12.6642L87.9295 13.1437C87.9495 13.1701 87.9815 13.1829 88.0096 13.1829L88.654 13.1589C88.666 13.1589 88.678 13.1565 88.686 13.1525L88.742 13.1281C88.778 13.1149 88.8181 13.1237 88.8501 13.1501L88.8981 13.2005C88.9221 13.2225 88.9541 13.2337 88.9862 13.2269L89.4385 13.1325C89.4745 13.1237 89.5145 13.1393 89.5345 13.1701L89.6826 13.3766C89.6826 13.381 89.6866 13.383 89.6866 13.3854L90.5351 14.9268C90.5351 14.9312 90.5391 14.9356 90.5432 14.94L90.6752 15.2982C90.7032 15.3687 90.6392 15.4411 90.5672 15.4279L90.2109 15.3599C90.1909 15.3555 90.1749 15.3579 90.1589 15.3623L89.7787 15.494C89.7467 15.5052 89.7226 15.5356 89.7146 15.5708L89.7106 15.584C89.7066 15.6437 89.6466 15.6809 89.5906 15.6633L87.9255 15.1465C87.9215 15.1445 87.9215 15.1446 87.9175 15.1421L87.3692 14.8936C87.3371 14.8784 87.2971 14.8828 87.2691 14.9048L87.165 14.9905C87.129 15.0193 87.121 15.0673 87.141 15.1093L87.4932 15.7998C87.5212 15.859 87.4852 15.9294 87.4172 15.9403L86.8608 16.0195C86.8328 16.0239 86.8048 16.0151 86.7848 15.9975L85.9042 15.2498C85.8642 15.2146 85.8162 15.1906 85.7641 15.1774L84.6194 14.8936L84.043 14.7551C83.927 14.7267 83.8349 14.643 83.7989 14.531L83.6948 14.2276C83.6908 14.2076 83.6828 14.1879 83.6708 14.1683L83.3506 13.5988C83.2906 13.4887 83.1745 13.4227 83.0464 13.4227L82.0058 13.4339C81.9938 13.4339 81.9817 13.4359 81.9697
13.4359L81.2293 13.5219C81.2092 13.5259 81.1892 13.5259 81.1692 13.5239L80.6849 13.4951C80.5929 13.4907 80.5048 13.5219 80.4368 13.5832L79.9445 14.0274C79.8804 14.0847 79.7964 14.1175 79.7083 14.1155L78.7677 14.0935C78.7317 14.0935 78.6957 14.0847 78.6596 14.0735L77.9512 13.8165L77.659 13.6976H77.567L77.583 14.0122L77.0827 14.3156L76.5583 14.8808L76.5023 15.8678L75.8739 16.4306C75.8659 16.4418 75.8539 16.4506 75.8419 16.4594L75.3536 16.7604C75.2975 16.7956 75.2575 16.8508 75.2415 16.9145L74.9773 17.9327L74.8493 18.5439C74.8373 18.5923 74.8172 18.636 74.7812 18.6712L74.0207 19.4517C73.9767 19.4981 73.9527 19.5597 73.9487 19.6258L73.9407 19.9268C73.9407 19.9816 73.9567 20.0368 73.9847 20.0805L74.3129 20.5448C74.3649 20.6216 74.3729 20.7205 74.3329 20.8061L74.2368 21.0062C74.2048 21.0679 74.2008 21.1383 74.2248 21.2044L74.2969 21.4265C74.3209 21.4881 74.3169 21.5582 74.2889 21.6178L73.9527 22.3499C73.9407 22.3695 73.9367 22.3895 73.9327 22.4091L73.7686 23.2757C73.7526 23.3569 73.7766 23.4406 73.8286 23.5018L74.0848 23.7704C74.1168 23.8056 74.1408 23.8516 74.1488 23.9021L74.2809 24.6409C74.2889 24.6938 74.3129 24.7398 74.3489 24.7774L75.3255 25.7777C75.3295 25.7845 75.3335 25.7889 75.3375 25.7933L76.2101 26.8487C76.2461 26.8928 76.2662 26.9476 76.2702 27.0068L76.2741 27.3587C76.2781 27.4575 76.3382 27.5476 76.4303 27.5872L78.4115 28.4626C78.4795 28.4934 78.5276 28.5458 78.5516 28.6143C78.5916 28.7283 78.7077 28.8012 78.8277 28.7856L81.1733 28.4998C81.1893 28.4978 81.2093 28.4954 81.2253 28.4978C81.3373 28.5086 81.7576 28.5482 81.7936 28.5482C81.8257 28.5482 83.0944 28.3789 83.3586 28.3437C83.3946 28.3393 83.4226 28.3305 83.4507 28.3129L83.979 28.0183C84.0831 27.9591 84.2192 27.9831 84.2952 28.0735L84.8276 28.6779C84.8876 28.7439 84.9756 28.7768 85.0637 28.7635L85.9603 28.6251C86.0123 28.6187 86.0683 28.6275 86.1123 28.6495L86.6167 28.898C86.6927 28.9353 86.7448 29.0057 86.7608 29.087L86.9249 30.1072C86.9329 30.138 86.9289 30.1688 86.9249 30.1997L86.6927 31.3672C86.6807 31.4396 86.6967 31.5145 86.7408 31.5737L87.4172 32.4599C87.4652 32.5171 87.4972 32.5832 87.5132 32.6556L87.8254 33.9968C87.8454 34.0805 87.8415 34.1686 87.8174 34.2518L87.5413 35.2544C87.5212 35.3161 87.5172 35.3821 87.5212 35.4458L87.5893 36.1122C87.5933 36.1298 87.5933 36.1474 87.5973 36.1626L87.7174 36.7586C87.7374 36.8687 87.7254 36.9827 87.6774 37.0816L87.3291 37.8097C87.3211 37.8273 87.3131 37.8449 87.3051 37.8625L86.4806 40.2392C86.4766 40.2504 86.4726 40.2612 86.4726 40.272L86.3165 41.0417C86.3005 41.1254 86.3245 41.2134 86.3885 41.2727L86.5567 41.442C86.5967 41.4836 86.6247 41.5364 86.6287 41.5937L86.7808 42.8292C86.7888 42.8757 86.7808 42.9217 86.7608 42.9637L86.2604 44.12C86.2564 44.1401 86.2484 44.1597 86.2444 44.1793L86.1164 44.9426C86.1124 44.9818 86.1123 45.0238 86.1243 45.0634L86.3845 45.8591L86.6046 46.4839C86.6207 46.5388 86.6207 46.6004 86.6046 46.6553L86.3005 47.5214C86.2965 47.5438 86.2885 47.5678 86.2885 47.5918L86.2604 48.1306C86.2564 48.2495 86.3285 48.3571 86.4445 48.3899L86.4966 48.4076C86.5326 48.4188 86.5726 48.4208 86.6127 48.4144L88.8501 48.0561C88.9061 48.0469 88.9541 48.0209 88.9942 47.9813L89.7707 47.1808C89.7747 47.1764 89.7787 47.172 89.7827 47.1656L91.7199 44.8129C91.7719 44.7512 91.7919 44.6696 91.7719 44.5907L91.7599 44.5335C91.7359 44.4346 91.7759 44.3334 91.852 44.2717L92.2002 44.0036C92.2322 43.9772 92.2602 43.9443 92.2762 43.9067L93.2649 41.7409C93.2729 41.7233 93.2769 41.7057 93.2809 41.6881L93.405 41.0965C93.413 41.0549 93.433 41.0133 93.465 40.9801L94.9419 39.307C94.97 39.2738 94.99 39.2322 94.998 39.1905Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1142">
              <path
                id="path1144"
                d="M96.7114 37.1502L95.9674 38.3906C95.9634 38.397 95.9594 38.4038 95.9514 38.4102L95.3354 39.2481C95.3114 39.2789 95.2995 39.3141 95.2915 39.3537L94.9315 41.216C94.9315 41.2312 94.9275 41.2444 94.9235 41.2576C94.8395 41.48 94.1035 43.4191 94.1035 43.5183V43.5202C94.1035 43.727 94.3315 43.8522 94.5035 43.7378L94.5835 43.6831C94.6275 43.6543 94.6595 43.6171 94.6795 43.5707L95.7714 41.0796L97.1473 38.219C97.1633 38.1862 97.1753 38.1486 97.1753 38.111L97.1913 37.289C97.1953 37.0226 96.8474 36.9239 96.7114 37.1502Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1146">
              <path
                id="path1148"
                d="M60.2334 58.0159L60.1504 58.2624C60.1278 58.3262 60.1731 58.3923 60.241 58.3942C60.2674 58.3964 60.2901 58.3878 60.3089 58.37L60.4864 58.2205C60.5279 58.1832 60.5317 58.1171 60.4939 58.0756L60.3995 57.9786C60.3467 57.9238 60.2561 57.9435 60.2334 58.0159Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1150">
              <path
                id="path1152"
                d="M78.4988 59.3365L77.3796 59.3761C77.3718 59.3761 77.3641 59.3761 77.3602 59.3784L75.5688 59.8051C75.5416 59.8117 75.5144 59.8051 75.4911 59.7915L75.0753 59.5234C75.0481 59.5078 75.0208 59.5036 74.9936 59.5102L73.5947 59.8972C73.5869 59.8996 73.5753 59.9015 73.5636 59.9015C73.3849 59.8883 71.8072 59.7783 71.7566 59.7783C71.7061 59.7783 70.0196 59.8246 69.8137 59.8312C69.7981 59.8312 69.7865 59.8358 69.7709 59.8401L68.7839 60.3173C68.78 60.3216 68.7683 60.3239 68.7645 60.3259L66.8021 60.7242C66.7943 60.7261 66.7904 60.7261 66.7826 60.7261L64.5676 60.7086C64.556 60.7086 64.5404 60.7063 64.5288 60.6997L62.1817 59.6862C62.1389 59.6687 62.1156 59.6244 62.1234 59.5786L62.1467 59.429C62.1545 59.3785 62.1234 59.3299 62.0768 59.3167L61.5871 59.1803C61.5521 59.1717 61.5249 59.143 61.5172 59.108L61.4317 58.7318C61.4278 58.7167 61.42 58.7035 61.4122 58.6902L61.2024 58.4373C61.1869 58.4198 61.1791 58.4 61.1791 58.3778L61.1636 58.114C61.1597 58.037 61.0781 57.9954 61.012 58.0351L60.5263 58.3339C60.4913 58.3537 60.4719 58.391 60.4757 58.4307L60.503 58.679C60.5107 58.7233 60.4874 58.7649 60.4447 58.7823L60.3164 58.8375C60.2543 58.8659 60.2348 58.9452 60.2814 58.9957L60.4252 59.1542C60.4719 59.2067 60.4524 59.2883 60.3864 59.3147L60.2387 59.3738C60.1727 59.4002 60.1532 59.4838 60.2037 59.5343L60.3825 59.7259C60.3941 59.7367 60.4019 59.7523 60.4058 59.7674L60.4485 59.9279C60.468 59.9917 60.4174 60.0554 60.3514 60.0534L58.9797 59.994C58.9175 59.9917 58.867 60.0488 58.8786 60.1106L58.9097 60.2952C58.9136 60.3348 58.9408 60.3655 58.9797 60.3744L64.6726 62.0543C64.6842 62.0586 64.692 62.0586 64.7036 62.0586L71.9898 61.9883C71.9976 61.9883 72.0054 61.9883 72.0131 61.9863L76.4936 60.8536C76.5014 60.8493 76.5131 60.845 76.5247 60.8403L78.5571 59.5191C78.6425 59.4639 78.5998 59.3322 78.4988 59.3365Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1154">
              <path
                id="path1156"
                d="M59.3656 45.1798L59.1032 44.2718C59.0842 44.2102 59.0994 44.1444 59.145 44.1003L59.5062 43.7266C59.5138 43.7178 59.5252 43.7091 59.5367 43.7022L60.4644 43.1152C60.4834 43.1019 60.5062 43.0931 60.5328 43.089C60.7077 43.0623 61.4606 42.9502 61.4948 42.9502C61.5214 42.9502 61.6773 42.7414 61.7572 42.627C61.7914 42.581 61.8446 42.5547 61.9016 42.5547C61.9967 42.5547 62.0765 42.4775 62.0765 42.3829L62.0841 41.9829C62.0879 41.9456 62.0993 41.908 62.1221 41.8772L62.548 41.3453C62.5822 41.3011 62.6088 41.2506 62.6202 41.1977L62.7685 40.6107C62.7799 40.5734 62.7951 40.5403 62.8103 40.5072L63.1183 39.9928C63.1373 39.9578 63.1487 39.916 63.1487 39.8719L63.0499 38.1107C63.0499 38.0514 63.0727 37.9921 63.1145 37.9503L63.9776 37.086C63.989 37.075 63.9966 37.0621 64.0042 37.0488L64.9624 35.5161C64.9814 35.483 64.9928 35.4435 64.9928 35.404V34.296C64.9928 34.1948 64.9244 34.1089 64.8217 34.0891L64.4263 34.0055C64.3844 33.9967 64.3464 33.9747 64.316 33.9462L63.6468 33.2626C63.624 33.2405 63.5974 33.223 63.567 33.212L61.5062 32.4641C61.4644 32.4489 61.4188 32.4466 61.3769 32.4599L60.3769 32.75C60.2362 32.7896 60.0994 32.6774 60.107 32.5325L60.1184 32.3303C60.126 32.2816 60.1108 32.2333 60.0842 32.1938L59.8598 31.8751C59.8294 31.8333 59.78 31.8025 59.7306 31.7915L58.6508 31.5607C58.6013 31.5519 58.5519 31.5584 58.5025 31.5827L57.955 31.8881C57.8371 31.9542 57.685 31.8903 57.647 31.7561L57.4682 31.0877C57.453 31.0284 57.4074 30.9778 57.3504 30.9516L57.0196 30.7953C56.9474 30.7622 56.9017 30.6942 56.8979 30.6151L56.8675 30.0611C56.8637 30.0326 56.8561 30.006 56.8447 29.982L56.0881 28.3878L55.3542 28.0908C55.3276 28.0775 55.2972 28.0733 55.2668 28.0775L54.1261 28.2075C54.0691 28.214 54.0121 28.1919 53.9741 28.1524L53.1452 27.2992C53.1338 27.2882 53.1224 27.2775 53.1186 27.2642L52.6243 26.4528C52.6091 26.4285 52.59 26.4064 52.5634 26.3912L52.1224 26.1163C52.0387 26.0612 52.0083 25.9513 52.0577 25.8658L52.0806 25.8304C52.149 25.7076 52.0653 25.5555 51.9247 25.5513L51.4076 25.5357C51.3695 25.5338 51.3353 25.5426 51.3049 25.5601L50.9323 25.7779C50.8981 25.7996 50.8563 25.8064 50.8182 25.8019L49.7308 25.6677C49.7156 25.6658 49.7004 25.6658 49.6852 25.6677L49.2441 25.7228C49.1985 25.7274 49.1453 25.7141 49.1072 25.6855L48.5483 25.2521C48.5407 25.2479 48.5331 25.2414 48.5255 25.2369L47.9894 24.9358C47.9362 24.9069 47.8715 24.905 47.8183 24.9312L46.5674 25.5182C46.5332 25.538 46.5027 25.5665 46.4837 25.6042L46.0959 26.3825C46.0541 26.4616 45.9628 26.5034 45.8754 26.4772L45.6891 26.4243C45.6662 26.4174 45.6472 26.4087 45.632 26.3958L45.2974 26.1559C45.2594 26.1274 45.2062 26.1163 45.1606 26.1228L44.5522 26.211C44.5256 26.2152 44.499 26.2262 44.48 26.2395L44.2632 26.3802C44.1872 26.4308 44.0845 26.4156 44.0237 26.3471L43.8792 26.1844C43.8488 26.1471 43.8298 26.0966 43.8336 26.0483L43.9553 24.3377C43.9591 24.3198 43.9629 24.3023 43.9705 24.2848L44.2024 23.6624C44.2899 23.4229 44.1568 23.1613 43.9096 23.0932L43.5218 22.9852C43.5142 22.983 43.5066 22.981 43.5028 22.981L43.0085 22.9347C42.9173 22.9259 42.8716 22.8248 42.9287 22.7544L43.7766 21.6571C43.7842 21.6461 43.788 21.6332 43.7956 21.6199L44.0389 20.7887C44.0389 20.7864 44.0389 20.7841 44.0389 20.7822L44.2442 20.2104C44.2556 20.1754 44.248 20.1355 44.229 20.1051C44.1682 20.0256 44.0541 19.8785 44.0237 19.8785C43.9933 19.8785 43.4229 19.9731 43.2556 20.0016C43.2252 20.0058 43.2024 20.0233 43.1834 20.0476L42.5903 20.8898L42.0884 21.5693C42.0541 21.6176 41.9857 21.6286 41.9401 21.5978L41.6245 21.4001C41.5903 21.378 41.5675 21.3362 41.5713 21.2944L41.6435 20.5294C41.6435 20.5248 41.6435 20.5203 41.6435 20.5138L41.6055 19.6937C41.6055 19.6849 41.6055 19.6762 41.6093 19.6674L41.6626 19.3792C41.6664 19.353 41.6854 19.3287 41.7044 19.3134L42.1758 18.9328C42.1873 18.9218 42.1986 18.9089 42.21 18.8933L43.248 16.6177C43.2594 16.5979 43.2709 16.5823 43.2899 16.5713L43.7499 16.2481C43.7727 16.2306 43.807 16.2242 43.8374 16.2306L44.2442 16.312C44.248 16.312 44.2518 16.3143 44.2556 16.3143L44.5598 16.4044C44.5864 16.4131 44.6206 16.4086 44.6435 16.3956L45.1681 16.1052C45.1872 16.0941 45.2062 16.09 45.229 16.0922L46.3164 16.1736C46.3811 16.1778 46.4267 16.2329 46.4191 16.2964L46.2784 17.572C46.2746 17.5831 46.2784 17.5937 46.2784 17.6047L46.3734 18.115C46.3849 18.1743 46.4381 18.2138 46.4989 18.2051L46.6054 18.1918C46.651 18.1853 46.6891 18.1523 46.7005 18.1062L47.2289 15.9998C47.2327 15.98 47.2404 15.9622 47.2556 15.9492L48.2594 14.909C48.2708 14.8983 48.2822 14.8892 48.2936 14.8827L50.0008 14.1637C50.0312 14.1504 50.0578 14.1219 50.0654 14.0888L50.3201 13.1546C50.3239 13.1368 50.3315 13.1239 50.343 13.1106L51.9019 11.3011C51.9437 11.2524 52.0083 11.2284 52.0767 11.2395L52.3467 11.2855C52.4076 11.2942 52.4722 11.2745 52.514 11.2304L52.8296 10.9007C52.8524 10.8787 52.8828 10.8611 52.9094 10.8524L53.5406 10.6589C53.5444 10.6566 53.552 10.6543 53.5558 10.6501L54.3961 10.1072C54.3999 10.1049 54.4075 10.1026 54.4113 10.1003L55.282 9.76384C55.282 9.76156 55.2858 9.76158 55.2934 9.76158L55.3999 9.73759C55.4797 9.7201 55.5253 9.82317 55.4607 9.86955L55.1147 10.1026V10.1049L54.7991 10.2916C54.7345 10.3288 54.7649 10.4304 54.8372 10.4281L55.3086 10.4193C55.32 10.4193 55.3276 10.4171 55.339 10.4148L56.704 9.81668C56.704 9.8144 56.7078 9.81443 56.7116 9.81215L56.9169 9.69808C56.9359 9.68934 56.9436 9.67144 56.9512 9.65167C56.9778 9.56156 57.0424 9.30227 57.0082 9.30227C56.974 9.30227 56.3656 9.32203 56.2059 9.32659C56.1793 9.32659 56.1565 9.31517 56.1451 9.2954L55.8942 8.95472C55.8713 8.92165 55.879 8.87337 55.9132 8.85131L56.2097 8.64257C56.2516 8.61633 56.2554 8.56121 56.2211 8.52813L55.9968 8.31065C55.9588 8.27985 55.9664 8.22472 56.0006 8.19848L56.244 8.02701C56.2668 8.01142 56.301 8.00914 56.3276 8.02701L56.7725 8.31481C56.7953 8.3304 56.8257 8.3327 56.8523 8.31711L57.1869 8.1038C57.2021 8.09505 57.2135 8.09087 57.2287 8.09087L58.0082 8.1038C58.0272 8.1038 58.0424 8.09962 58.0538 8.09087L58.3162 7.89924C58.32 7.89506 58.3275 7.8928 58.3314 7.89052L58.7914 7.71029C58.8104 7.70154 58.8332 7.7038 58.8523 7.71255C58.9055 7.74107 58.9055 7.81369 58.856 7.84221L58.4378 8.08631C58.4302 8.09087 58.4264 8.09277 58.4226 8.09734L57.8104 8.6996C57.7686 8.73952 57.7839 8.80757 57.8409 8.82506L58.1565 8.91748C58.1641 8.91976 58.1717 8.91975 58.1755 8.91975L59.1678 8.93267C59.183 8.93267 59.1983 8.93952 59.2135 8.94826L59.3465 9.0536C59.3846 9.0844 59.4454 9.06689 59.4606 9.01632L59.5671 8.68898C59.5709 8.67795 59.5747 8.66235 59.5671 8.65133L59.4986 8.34563C59.4948 8.3346 59.491 8.32355 59.4834 8.31481L59.1982 7.96541C59.1754 7.93233 59.1793 7.88631 59.2097 7.8597L59.723 7.4464C59.7458 7.43119 59.7572 7.40456 59.7534 7.38023L59.6697 6.76924C59.6659 6.74947 59.6545 6.72969 59.6393 6.71867L59.0842 6.35364C59.0614 6.33805 59.05 6.31185 59.05 6.28561L59.1146 5.59283L59.145 5.02554C59.1488 4.96851 59.088 4.92898 59.0348 4.95522L58.2553 5.37078C58.2401 5.37725 58.2211 5.37952 58.2059 5.37724L57.8637 5.31375C57.8067 5.30272 57.7839 5.23428 57.8219 5.19055L58.0234 4.97497C58.0462 4.95102 58.05 4.91567 58.0348 4.88715C57.974 4.78601 57.8333 4.54421 57.8257 4.46056C57.8105 4.3617 56.9588 4.575 56.8485 4.60351C56.8409 4.60541 56.8333 4.60767 56.8257 4.61224L56.0158 5.14644C56.0006 5.15328 55.993 5.16621 55.9854 5.17952L55.7801 5.6917C55.7763 5.70501 55.7649 5.71374 55.7573 5.72248C55.6774 5.7799 55.3467 6.02819 55.3124 6.03921C55.2744 6.05252 54.7649 6.3932 54.7117 6.43046C54.7079 6.43274 54.7041 6.43501 54.7003 6.43729L53.8638 6.81751C53.8486 6.82436 53.8334 6.83729 53.8258 6.85059C53.7687 6.9582 53.5292 7.41334 53.4988 7.45972C53.4684 7.49699 53.3277 7.45744 53.2364 7.43121C53.1984 7.4179 53.1756 7.37833 53.187 7.33879L53.3467 6.81105C53.3505 6.79546 53.3581 6.78445 53.3695 6.7757L53.6699 6.51638C53.7003 6.49205 53.7041 6.45023 53.6851 6.41943L53.3201 5.86774C53.3011 5.83694 53.3048 5.79739 53.3315 5.77306L53.879 5.24989C53.8866 5.24114 53.898 5.2343 53.9094 5.2324L54.6166 5.03011C54.6242 5.02783 54.6318 5.02326 54.6394 5.01908L55.1375 4.67614C55.1375 4.67386 55.1413 4.66927 55.1451 4.66927L55.7421 4.41645C55.7535 4.40998 55.7649 4.40998 55.7763 4.40998L56.3542 4.47155C56.3694 4.47345 56.3846 4.47156 56.3961 4.46472L56.7534 4.28679C56.7648 4.28032 56.7801 4.27805 56.7953 4.28033L57.0614 4.32214C57.0843 4.32632 57.1108 4.31757 57.126 4.29551L57.5139 3.82291C57.5177 3.81835 57.5253 3.81416 57.5291 3.81188L57.9435 3.50849C57.9511 3.50393 57.9625 3.49974 57.9701 3.49746L58.9891 3.229C59.0005 3.2271 59.012 3.21838 59.0234 3.20925L59.2667 2.95219C59.2781 2.94117 59.2933 2.93436 59.3085 2.93018L59.6203 2.8773C59.6926 2.86399 59.7382 2.9564 59.6811 3.00507L59.491 3.16325C59.4834 3.16971 59.4796 3.17427 59.4682 3.17617L58.9549 3.3678C58.9321 3.37654 58.9131 3.39629 58.9055 3.42253L58.8827 3.52367C58.8789 3.55029 58.8599 3.57235 58.8332 3.57881L57.9397 3.84916C57.9245 3.85373 57.9093 3.86244 57.9017 3.87575L57.8104 3.99438C57.78 4.03621 57.799 4.09554 57.8485 4.11075L58.0652 4.17688C58.0804 4.18106 58.0956 4.18106 58.1108 4.17688L58.5291 4.03812C58.5671 4.02519 58.6089 4.04496 58.6241 4.0845L58.6812 4.2693C58.6888 4.29135 58.704 4.30884 58.723 4.3153L59.0006 4.42517C59.0348 4.43848 59.0728 4.4252 59.0918 4.3925L59.2439 4.1305C59.2667 4.09552 59.3123 4.0845 59.3503 4.10655L59.4682 4.18108C59.4834 4.1921 59.5062 4.19667 59.5253 4.1921L60.088 4.07577C60.1184 4.07121 60.1412 4.04723 60.145 4.01644L60.1868 3.74572C60.1906 3.73051 60.1982 3.7195 60.2058 3.70847L60.3807 3.50849C60.415 3.46894 60.4796 3.47769 60.5024 3.52597L60.5366 3.60087C60.5556 3.64459 60.6089 3.65789 60.6469 3.63165L60.9511 3.40961C60.9625 3.40086 60.9701 3.38757 60.9739 3.37426L61.183 2.79595C61.1906 2.78264 61.1906 2.76971 61.1868 2.7564L61.1222 2.43968C61.1146 2.4066 61.0918 2.38034 61.0537 2.38034L60.0081 2.32981L58.8104 2.30355L50.9589 4.69779L47.4077 7.60457L41.423 13.4292C41.4116 13.4402 41.404 13.4512 41.4002 13.4668L39.9059 17.0135C39.8983 17.0287 39.8945 17.0443 39.8945 17.0618L39.9477 18.6846C39.9477 18.691 39.9477 18.6956 39.9477 18.702L40.
0162 19.067C40.0238 19.1222 40.0732 19.1617 40.1265 19.1617L40.3394 19.1549C40.385 19.1549 40.4268 19.1264 40.442 19.0826L40.7728 18.1876C40.7766 18.183 40.7766 18.1789 40.7804 18.1743C40.8413 18.0599 41.0124 18.1215 40.9896 18.2469L40.9363 18.5416C40.9363 18.5458 40.9325 18.5503 40.9325 18.5568L40.5675 19.6716C40.5675 19.6784 40.5637 19.6826 40.5637 19.6872L40.1378 20.5294C40.1302 20.5423 40.1265 20.5556 40.1265 20.5712L40.0846 21.0548C40.0846 21.0678 40.0846 21.0811 40.0884 21.0944L40.4078 22.1917C40.4078 22.1959 40.4078 22.1981 40.4116 22.2023L40.6816 22.8909C40.7006 22.9415 40.7538 22.97 40.8071 22.959L41.1797 22.8841C41.1911 22.8818 41.2025 22.8776 41.2139 22.8689L41.4192 22.7411C41.4762 22.7038 41.5561 22.7301 41.5827 22.794L41.6854 23.0468C41.6892 23.0533 41.6891 23.0601 41.6891 23.0666L41.7918 23.5373C41.8032 23.5989 41.845 23.6495 41.9021 23.6712L42.2405 23.8053C42.2899 23.8251 42.3317 23.8669 42.3469 23.9175L42.4458 24.1947C42.4648 24.2517 42.5142 24.2935 42.5675 24.311L42.9439 24.4255C43.0237 24.4498 43.0807 24.5289 43.0769 24.6145L43.0313 25.4019C43.0313 25.4038 43.0313 25.4084 43.0313 25.4129V26.0943C43.0313 26.1669 43.0732 26.2331 43.1378 26.2635L43.2443 26.3122C43.2519 26.3163 43.2633 26.3209 43.2747 26.3232L43.4496 26.3737C43.518 26.3935 43.5713 26.4528 43.5827 26.5254L43.6092 26.7144C43.6207 26.7893 43.6739 26.8486 43.7423 26.8684L43.94 26.9231C43.9819 26.9345 44.0161 26.9608 44.0427 26.9939L44.2252 27.2509C44.2518 27.2882 44.2899 27.3148 44.3355 27.3258C44.4648 27.3543 44.5826 27.2444 44.5598 27.1125L44.5104 26.8201C44.4952 26.7319 44.5446 26.6463 44.6283 26.6156L44.9856 26.4772C45.0313 26.4593 45.0807 26.4616 45.1263 26.4813L45.4799 26.633C45.5408 26.6616 45.5864 26.7209 45.594 26.7893L45.6777 27.7106C45.6777 27.717 45.6777 27.7258 45.6777 27.7326L45.6434 28.9353C45.6434 28.9573 45.6396 28.9771 45.632 28.9969L45.4305 29.5311C45.3925 29.6299 45.3164 29.7113 45.2214 29.7531L44.4305 30.114C44.3051 30.1687 44.2176 30.2854 44.1986 30.4174L44.0921 31.1341C44.0921 31.1451 44.0921 31.1561 44.0921 31.1672V32.7238C44.0921 32.8162 44.1492 32.8975 44.2366 32.9261C44.3583 32.9656 44.4191 33.104 44.3621 33.2185L44.2366 33.4759C44.2176 33.5196 44.2138 33.5702 44.2214 33.6184L44.3621 34.1861C44.3621 34.1903 44.3621 34.1949 44.3621 34.199L44.4267 34.5618C44.4381 34.6127 44.4647 34.6587 44.5028 34.6918L44.8944 35.004C44.921 35.0237 44.94 35.0522 44.9515 35.0808L46.4191 38.3392C46.4267 38.3571 46.4343 38.3792 46.4381 38.3989L46.5179 39.0012C46.5255 39.0674 46.5636 39.1244 46.6168 39.1575L48.9095 40.5118C48.9589 40.5403 48.9932 40.5844 49.0084 40.6373L49.9931 44.1376C49.9969 44.1444 49.9969 44.1509 49.9969 44.1574L50.0236 45.0961C50.0236 45.103 50.0274 45.1094 50.0274 45.1163L50.3658 46.2242L50.8753 47.9615C50.8753 47.9702 50.8791 47.979 50.8791 47.9877L50.8144 49.1884C50.8144 49.2036 50.8182 49.2188 50.822 49.2322L51.3772 50.1842L52.0159 51.3827C52.0235 51.3914 52.0273 51.3979 52.0349 51.4025L52.4912 51.8378C52.495 51.8401 52.4988 51.8424 52.5026 51.8443L52.7687 52.0226C52.7954 52.0401 52.8068 52.0731 52.7992 52.1062L52.7497 52.315C52.7459 52.3237 52.7459 52.3325 52.7459 52.3416L52.7992 52.7701C52.7992 52.7834 52.7954 52.7944 52.7954 52.8055L52.7231 52.9944C52.7079 53.0385 52.7345 53.0868 52.7801 53.0978L53.263 53.2032C53.2858 53.2077 53.3049 53.221 53.3163 53.2408L53.898 54.3157C53.9018 54.3225 53.9094 54.3313 53.917 54.3377L54.5558 54.8742C54.5596 54.8788 54.5634 54.8811 54.571 54.8853L55.5671 55.402C55.5748 55.4065 55.5786 55.4088 55.5786 55.4107L56.1869 55.8902C56.1983 55.9012 56.2135 55.9077 56.2287 55.9077L57.012 55.9453C57.0272 55.9453 57.0424 55.9407 57.0538 55.9343L57.2591 55.8111C57.3124 55.7803 57.3086 55.7035 57.2591 55.6746L56.5139 55.2746C56.5063 55.27 56.4949 55.2613 56.4911 55.2525L55.685 54.1773C55.666 54.1552 55.6622 54.129 55.6736 54.1047L55.8485 53.5769C55.8599 53.5397 55.8409 53.5001 55.8067 53.4826L54.879 53.0275C54.8524 53.0119 54.8334 52.9834 54.8372 52.9526L54.8486 52.7328C54.8486 52.7062 54.8676 52.68 54.8904 52.6667L55.1147 52.5568C55.1451 52.5416 55.1603 52.5062 55.1565 52.4712L55.0577 51.9564C55.0501 51.9237 55.0653 51.8884 55.0995 51.8732L55.2592 51.7918C55.3086 51.7675 55.3162 51.7017 55.2782 51.664L54.6546 51.099C54.6128 51.0618 54.6242 50.9956 54.6698 50.9713L54.7991 50.9078C54.8105 50.9013 54.8219 50.899 54.8333 50.899H55.0843C55.1299 50.899 55.1641 50.8595 55.1603 50.8154L55.1033 50.0987C55.0995 50.0546 55.1299 50.0196 55.1717 50.0127L56.4911 49.8679C56.5063 49.8656 56.5215 49.8588 56.5367 49.8458L56.9512 49.461C56.9816 49.4321 56.9854 49.382 56.955 49.3508L56.5291 48.8938C56.5215 48.8869 56.5177 48.8759 56.5139 48.8671L56.32 48.3352C56.3124 48.3155 56.2972 48.298 56.2782 48.2888C56.1945 48.2516 56.2288 48.1284 56.32 48.1417L56.7915 48.212C56.8067 48.2143 56.8219 48.2208 56.8333 48.2318L57.1375 48.509C57.1641 48.5329 57.2059 48.5352 57.2363 48.5154L58.0766 47.9504C58.088 47.9394 58.0994 47.9261 58.1032 47.9109L58.2059 47.6162C58.2135 47.5964 58.2135 47.5744 58.2059 47.5546L57.955 47.06C57.9474 47.0379 57.9473 47.0094 57.9587 46.9873L58.0538 46.8159C58.0766 46.7763 58.1299 46.763 58.1641 46.7896L58.4683 46.9873L58.8751 45.9364L59.3351 45.336C59.3694 45.2919 59.3808 45.2326 59.3656 45.1798Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1158">
              <path
                id="path1160"
                d="M47.6702 21.0285C47.7145 21.0263 47.7552 20.9956 47.77 20.9494L47.8181 20.7867C47.8328 20.7468 47.8218 20.7032 47.7922 20.6743L47.2672 20.1468C47.2635 20.1446 47.2599 20.1401 47.2562 20.1379L46.6314 19.3464C46.6203 19.3331 46.6092 19.3242 46.5944 19.3157L46.0103 19.0255C45.9807 19.0078 45.9401 19.01 45.9068 19.0255L45.2376 19.3904C45.2191 19.4015 45.2043 19.4166 45.1932 19.4344L45.0528 19.685C45.0084 19.7619 45.0639 19.8544 45.1489 19.8544H45.4964C45.4964 19.8544 45.5001 19.8544 45.5038 19.8544L46.0953 19.8895C46.1323 19.8917 46.1692 19.9117 46.1877 19.9446L46.3652 20.2499C46.3763 20.2655 46.38 20.2832 46.38 20.3028L46.3911 20.5557C46.3911 20.5778 46.3984 20.5996 46.4132 20.6174L46.7386 21.0418C46.7608 21.0725 46.7977 21.0876 46.8347 21.0858L47.6702 21.0285Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1162">
              <path
                id="path1164"
                d="M48.0924 21.4835L47.9256 21.5428C47.8403 21.5736 47.8218 21.6859 47.8959 21.7408L47.9219 21.7586C47.9441 21.776 47.9738 21.7827 48.0071 21.7782L48.6374 21.6815C48.6486 21.6815 48.6634 21.6815 48.6745 21.6837L49.2418 21.7804C49.264 21.7827 49.2862 21.7804 49.3048 21.7715L49.4753 21.7011C49.5383 21.6748 49.5643 21.6025 49.5347 21.545L49.4197 21.3296C49.4123 21.31 49.3938 21.2922 49.3752 21.2814L48.9711 21.0679C48.9637 21.0638 48.9526 21.0593 48.9415 21.0593L48.5299 20.9733C48.5188 20.9711 48.5039 20.9711 48.4928 20.9733L48.174 21.0241C48.0961 21.0371 48.0553 21.1164 48.085 21.1824L48.1554 21.3296C48.1851 21.3912 48.1554 21.4616 48.0924 21.4835Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1166">
              <path
                id="path1168"
                d="M46.6811 21.6041L46.4302 21.6657C46.349 21.6853 46.3157 21.7864 46.3711 21.8503L46.4006 21.8831C46.4228 21.9075 46.4523 21.9208 46.4818 21.923L46.6848 21.9296C46.7439 21.9315 46.7918 21.8898 46.8029 21.8326L46.8177 21.7292C46.8288 21.6502 46.7549 21.5864 46.6811 21.6041Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1170">
              <path
                id="path1172"
                d="M50.903 21.7242L50.338 21.6759C50.2749 21.6692 50.2191 21.7175 50.2154 21.7811V21.8164C50.2117 21.8539 50.2265 21.8911 50.2563 21.9134C50.3083 21.9528 50.3826 22.0078 50.4086 22.0078C50.4347 22.0078 50.7283 21.9881 50.9104 21.977C50.9884 21.9725 51.0368 21.8956 51.007 21.8253L50.9959 21.7967C50.981 21.7569 50.9476 21.7283 50.903 21.7242Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1174">
              <path
                id="path1176"
                d="M60.7432 2.02465C60.7815 2.02465 61.5814 1.94545 61.6809 1.93435C61.6886 1.93435 61.6962 1.93204 61.7001 1.93012L62.4962 1.72993C62.5115 1.72534 62.5306 1.72342 62.5459 1.72534L63.1392 1.80039C63.1469 1.8023 63.1545 1.8023 63.1621 1.80039L63.3688 1.79157C63.4148 1.78927 63.4569 1.81146 63.4875 1.84629L63.5908 1.98256C63.6138 2.01127 63.6444 2.02887 63.6788 2.03538C63.7822 2.05528 63.8281 2.18042 63.7631 2.26424L63.6023 2.46211C63.5755 2.49273 63.564 2.53446 63.5717 2.57656L63.5946 2.73044C63.6061 2.78096 63.587 2.83568 63.5449 2.86668L63.0473 3.24064C63.0282 3.25595 63.0129 3.27356 63.0052 3.29308L62.7794 3.75274C62.7641 3.78375 62.7641 3.82086 62.7717 3.85377L62.921 4.34637C62.9325 4.39268 62.9708 4.42788 63.0167 4.44089L63.8243 4.67629C63.8396 4.68089 63.8549 4.68741 63.8702 4.69812L64.008 4.79953C64.1917 4.93349 64.4482 4.90287 64.5974 4.72911L65.5237 3.64517C65.5466 3.61876 65.5772 3.60118 65.6117 3.59658L66.4652 3.49323C66.5073 3.48902 66.5456 3.4626 66.5685 3.4251L66.6642 3.26015C66.6872 3.22073 66.7293 3.19431 66.7752 3.19201C67.0546 3.17211 68.0115 3.10399 68.046 3.10399C68.0804 3.10399 68.5282 2.76566 68.6201 2.69523C68.6315 2.68643 68.6392 2.67763 68.6507 2.66653L69.0678 2.08169C69.0946 2.04648 69.1023 2.00017 69.0908 1.95846L68.953 1.48807C68.9454 1.45285 68.9224 1.42413 68.8918 1.40423L68.31 1.0678C68.2909 1.05708 68.2679 1.05057 68.2488 1.05057L63.7707 0.804102C63.7516 0.801805 63.7363 0.804099 63.7171 0.810606L60.8963 1.71655C60.858 1.72995 60.8274 1.75867 60.8121 1.79579C60.7739 1.87923 60.7164 2.02465 60.7432 2.02465Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1178">
              <path
                id="path1180"
                d="M71.4442 1.52821L72.0451 1.85134C72.0528 1.85557 72.0643 1.85982 72.0759 1.86213L72.8886 2.02503C72.9656 2.04044 73.0349 1.9765 73.0234 1.90178L73.0002 1.71729C72.9964 1.6753 72.9656 1.64027 72.9232 1.62679L71.9488 1.28824C71.9334 1.284 71.918 1.28169 71.9025 1.28169L71.4905 1.31483C71.3788 1.32562 71.348 1.47313 71.4442 1.52821Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1182">
              <path
                id="path1184"
                d="M69.2717 4.06041C69.287 4.07346 69.31 4.0823 69.3292 4.0823H69.9087C69.9126 4.0823 69.9203 4.0823 69.9241 4.0823L70.3923 4.15482C70.4154 4.15943 70.4384 4.15251 70.4576 4.13946L70.7492 3.9349C70.7684 3.91954 70.7838 3.89539 70.7876 3.86661L70.803 3.61599C70.8068 3.56341 70.7646 3.51737 70.7109 3.51929L69.9049 3.54152C69.8934 3.54152 69.8819 3.54347 69.8742 3.54807L69.2295 3.80098C69.2218 3.8029 69.2141 3.8052 69.2064 3.8075C69.1258 3.81633 69.0951 3.91726 69.1603 3.96792L69.2717 4.06041Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1186">
              <path
                id="path1188"
                d="M81.8014 10.7913C81.7623 10.7627 81.7115 10.7584 81.6685 10.7803L81.6139 10.8112C81.5475 10.8463 81.5318 10.9276 81.5748 10.987L81.7311 11.1983C81.7819 11.2686 81.8912 11.2596 81.9303 11.1827C81.9381 11.1717 81.942 11.1588 81.942 11.1455C81.9498 11.0924 81.9694 10.9475 81.9459 10.9213C81.9303 10.8991 81.8561 10.8354 81.8014 10.7913Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1190">
              <path
                id="path1192"
                d="M81.919 11.6732L81.9699 12.1768C81.9738 12.221 82.0011 12.2581 82.0441 12.2757L82.3296 12.3856C82.396 12.4122 82.4664 12.377 82.486 12.3109L82.5759 12.0165C82.5798 12.0008 82.5798 11.9879 82.5798 11.9723L82.5681 11.823C82.5681 11.7768 82.5368 11.7393 82.4977 11.7217L82.0793 11.5524C81.9972 11.5172 81.9073 11.5833 81.919 11.6732Z"
                fill="#B4DBAD"
              />
            </g>
            <g id="g1194">
              <path
                id="path1196"
                d="M83.7239 12.896L84.0377 13.085C84.0416 13.0893 84.0494 13.0917 84.0533 13.0937L84.426 13.2412C84.5044 13.2741 84.5907 13.2106 84.5868 13.1247L84.575 12.9466C84.575 12.896 84.5397 12.854 84.4887 12.8387L83.8572 12.6587C83.8258 12.6497 83.7945 12.652 83.7631 12.6693L83.7239 12.6936C83.6493 12.7375 83.6493 12.8497 83.7239 12.896Z"
                fill="#B4DBAD"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="path1200"
        d="M97.3678 20.0773C101.513 30.7009 99.3841 43.2265 90.8957 51.9343C79.3024 63.8297 60.2369 64.0999 48.3089 52.534C48.1355 52.3671 47.9661 52.1981 47.8008 52.0288"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1204"
        d="M39.3848 27.9297C40.0693 21.4583 42.8513 15.1588 47.7347 10.1311C59.335 -1.80664 78.4045 -2.07539 90.333 9.52745C93.0149 12.1415 95.1124 15.1348 96.6135 18.3396"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1208"
        d="M105.03 33.8871C101.508 33.8871 98.6499 31.0112 98.6499 27.4638C98.6499 23.916 101.508 21.0422 105.03 21.0422C108.552 21.0422 111.406 23.916 111.406 27.4638C111.406 31.0112 108.552 33.8871 105.03 33.8871ZM105.03 13.9051C97.5941 13.9051 91.5645 19.9745 91.5645 27.4638C91.5645 34.9527 105.03 53.1797 105.03 53.1797C105.03 53.1797 118.496 34.9527 118.496 27.4638C118.496 19.9745 112.466 13.9051 105.03 13.9051Z"
        fill="#CF6367"
      />
      <g id="Clip path group_2">
        <mask
          id="mask1_1538_111"
          maskUnits="userSpaceOnUse"
          x="1"
          y="65"
          width="90"
          height="49"
        >
          <g id="clipPath1216">
            <path
              id="path1214"
              d="M1 113.352H90.2006V65.8489H1V113.352Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask1_1538_111)">
          <g id="g1212">
            <g id="g1218">
              <path
                id="path1226"
                d="M1 113.359H90.1994V65.8565H1V113.359Z"
                fill="#A2C4E2"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Clip path group_3">
        <mask
          id="mask2_1538_111"
          maskUnits="userSpaceOnUse"
          x="1"
          y="65"
          width="90"
          height="49"
        >
          <g id="clipPath1234">
            <path
              id="path1232"
              d="M1 113.016H90.2006V65.5129L1 113.016Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask2_1538_111)">
          <g id="g1230">
            <g id="g1236">
              <path
                id="path1244"
                d="M1 113.012H90.1994V65.5092L1 113.012Z"
                fill="#7091B0"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="path1248"
        d="M3.19727 112.934H92.4067V65.5235H3.19727V112.934Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1252"
        d="M98.7796 67.4863H126.348C127.397 67.4863 128.331 68.1569 128.667 69.1514L135.889 90.5094V117.141H96.334V69.9368C96.334 68.5823 97.4294 67.4863 98.7796 67.4863Z"
        fill="white"
      />
      <path
        id="path1256"
        d="M130.84 108.164H135.889V96.6622H130.84V108.164Z"
        fill="#FFF299"
      />
      <path
        id="path1260"
        d="M109.801 71.1315H129.32L135.89 90.4883H109.801V71.1315Z"
        fill="#B3D4F3"
      />
      <path
        id="path1264"
        d="M105.312 90.4883H101.104V71.1315H105.312V90.4883Z"
        fill="#B3D4F3"
      />
      <path
        id="path1268"
        d="M96.334 117.141V69.9368C96.334 68.5823 97.4294 67.4863 98.7796 67.4863H126.348C127.397 67.4863 128.331 68.1569 128.667 69.1514L135.889 90.5094V117.141"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1272"
        d="M130.84 108.164H135.889V96.6622H130.84V108.164Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1276"
        d="M135.889 120.227H140.377V98.6255"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1280"
        d="M109.801 71.1315H129.32L135.89 90.4883H109.801V71.1315Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1284"
        d="M105.312 90.4883H101.104V71.1315H105.312V90.4883Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1288"
        d="M109.801 98.625H115.131"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1292"
        d="M121.582 124.434C121.582 115.603 114.359 108.443 105.451 108.443C96.5424 108.443 89.3203 115.603 89.3203 124.434"
        fill="#B3D4F3"
      />
      <path
        id="path1296"
        d="M78.3804 124.434C78.3804 115.602 71.1569 108.443 62.2498 108.443C53.3387 108.443 46.1191 115.602 46.1191 124.434"
        fill="#B3D4F3"
      />
      <path
        id="path1300"
        d="M43.8746 124.434C43.8746 115.602 36.6536 108.443 27.7421 108.443C18.8379 108.443 11.6133 115.602 11.6133 124.434"
        fill="#B3D4F3"
      />
      <path
        id="path1304"
        d="M135.889 117.14H3.19727V124.434H135.889V117.14Z"
        fill="#FFF299"
      />
      <path
        id="path1308"
        d="M115.41 124.576C115.41 117.682 109.882 112.091 103.066 112.091C96.2501 112.091 90.7227 117.682 90.7227 124.576C90.7227 131.47 96.2501 137.059 103.066 137.059C109.882 137.059 115.41 131.47 115.41 124.576Z"
        fill="#7091B0"
      />
      <path
        id="path1312"
        d="M110.642 124.577C110.642 121.555 108.193 119.106 105.172 119.106C102.15 119.106 99.7012 121.555 99.7012 124.577C99.7012 127.599 102.15 130.047 105.172 130.047C108.193 130.047 110.642 127.599 110.642 124.577Z"
        fill="white"
      />
      <path
        id="path1316"
        d="M37.9838 124.576C37.9838 117.682 32.4555 112.091 25.6385 112.091C18.8252 112.091 13.2969 117.682 13.2969 124.576C13.2969 131.47 18.8252 137.059 25.6385 137.059C32.4555 137.059 37.9838 131.47 37.9838 124.576Z"
        fill="#7091B0"
      />
      <path
        id="path1320"
        d="M33.2149 124.576C33.2149 121.554 30.8311 119.106 27.8866 119.106C24.9421 119.106 22.5547 121.554 22.5547 124.576C22.5547 127.599 24.9421 130.047 27.8866 130.047C30.8311 130.047 33.2149 127.599 33.2149 124.576Z"
        fill="white"
      />
      <path
        id="path1324"
        d="M72.4877 124.576C72.4877 117.682 66.9603 112.091 60.1462 112.091C53.3282 112.091 47.8008 117.682 47.8008 124.576C47.8008 131.47 53.3282 137.059 60.1462 137.059C66.9603 137.059 72.4877 131.47 72.4877 124.576Z"
        fill="#7091B0"
      />
      <path
        id="path1328"
        d="M67.7201 124.576C67.7201 121.555 65.2713 119.106 62.2478 119.106C59.228 119.106 56.7793 121.555 56.7793 124.576C56.7793 127.598 59.228 130.047 62.2478 130.047C65.2713 130.047 67.7201 127.598 67.7201 124.576Z"
        fill="white"
      />
      <path
        id="path1332"
        d="M13.2965 117.14H3.19727V124.434H11.5353"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1336"
        d="M49.7674 117.141H40.5098"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1340"
        d="M91.0044 117.141H76.6973"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1344"
        d="M121.301 124.434H135.888V117.14H123.609"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1348"
        d="M78.3809 124.434H89.0411"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1352"
        d="M43.875 124.434H46.1193"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1356"
        d="M117.654 124.576C117.654 117.682 112.128 112.091 105.31 112.091C98.4921 112.091 92.9668 117.682 92.9668 124.576C92.9668 131.47 98.4921 137.059 105.31 137.059C112.128 137.059 117.654 131.47 117.654 124.576Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1360"
        d="M110.642 124.577C110.642 121.555 108.193 119.106 105.172 119.106C102.15 119.106 99.7012 121.555 99.7012 124.577C99.7012 127.599 102.15 130.047 105.172 130.047C108.193 130.047 110.642 127.599 110.642 124.577Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1364"
        d="M121.302 124.434C121.302 115.603 114.081 108.443 105.174 108.443C96.2622 108.443 89.041 115.603 89.041 124.434"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1368"
        d="M140.377 108.164H135.889"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1372"
        d="M40.2279 124.576C40.2279 117.682 34.7019 112.091 27.8863 112.091C21.0671 112.091 15.541 117.682 15.541 124.576C15.541 131.47 21.0671 137.059 27.8863 137.059C34.7019 137.059 40.2279 131.47 40.2279 124.576Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1376"
        d="M33.2142 124.576C33.2142 121.555 30.7648 119.106 27.7438 119.106C24.7228 119.106 22.2734 121.555 22.2734 124.576C22.2734 127.598 24.7228 130.047 27.7438 130.047C30.7648 130.047 33.2142 127.598 33.2142 124.576Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1380"
        d="M43.8746 124.434C43.8746 115.603 36.6512 108.443 27.7439 108.443C18.8367 108.443 11.6133 115.603 11.6133 124.434"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1384"
        d="M74.7318 124.576C74.7318 117.682 69.2039 112.091 62.3884 112.091C55.5729 112.091 50.0449 117.682 50.0449 124.576C50.0449 131.47 55.5729 137.059 62.3884 137.059C69.2039 137.059 74.7318 131.47 74.7318 124.576Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1388"
        d="M67.7201 124.576C67.7201 121.555 65.2713 119.106 62.2478 119.106C59.228 119.106 56.7793 121.555 56.7793 124.576C56.7793 127.598 59.228 130.047 62.2478 130.047C65.2713 130.047 67.7201 127.598 67.7201 124.576Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1392"
        d="M78.3804 124.434C78.3804 115.602 71.1591 108.443 62.2498 108.443C53.3405 108.443 46.1191 115.602 46.1191 124.434"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1396"
        d="M107.278 33.8872C103.753 33.8872 100.898 31.0115 100.898 27.4638C100.898 23.9161 103.753 21.0425 107.278 21.0425C110.799 21.0425 113.654 23.9161 113.654 27.4638C113.654 31.0115 110.799 33.8872 107.278 33.8872ZM107.278 13.9051C99.8389 13.9051 93.8105 19.9751 93.8105 27.4638C93.8105 34.9525 107.278 53.1797 107.278 53.1797C107.278 53.1797 120.742 34.9525 120.742 27.4638C120.742 19.9751 114.713 13.9051 107.278 13.9051Z"
        fill="#CF6367"
      />
      <path
        id="path1400"
        d="M107.278 33.8872C103.753 33.8872 100.898 31.0115 100.898 27.4638C100.898 23.9161 103.753 21.0425 107.278 21.0425C110.799 21.0425 113.654 23.9161 113.654 27.4638C113.654 31.0115 110.799 33.8872 107.278 33.8872ZM107.278 13.9051C99.8389 13.9051 93.8105 19.9751 93.8105 27.4638C93.8105 34.9525 107.278 53.1797 107.278 53.1797C107.278 53.1797 120.742 34.9525 120.742 27.4638C120.742 19.9751 114.713 13.9051 107.278 13.9051Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1404"
        d="M48.3635 43.7905C43.1649 45.2031 39.0994 49.3158 37.694 54.582C36.2996 49.3135 32.2416 45.1968 27.043 43.7726C32.2416 42.3599 36.307 38.2473 37.7124 32.981C39.1068 38.2495 43.1649 42.3666 48.3635 43.7905Z"
        fill="white"
      />
      <path
        id="path1408"
        d="M23.9571 37.1952C20.6036 38.1133 17.9851 40.7839 17.0805 44.2031C16.1794 40.7817 13.5644 38.1086 10.2109 37.184C13.5644 36.2663 16.1864 33.5953 17.0911 30.1765C17.9886 33.5975 20.6071 36.271 23.9571 37.1952Z"
        fill="white"
      />
      <path
        id="path1412"
        d="M50.6076 43.7894C45.4086 45.2044 41.3431 49.3164 39.9363 54.582C38.5442 49.3142 34.4825 45.1955 29.2871 43.7737C34.4861 42.3586 38.5516 38.2488 39.9548 32.981C41.3505 38.2511 45.4086 42.3676 50.6076 43.7894Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1416"
        d="M26.2012 37.1956C22.8489 38.1132 20.2274 40.7821 19.3264 44.2031C18.4218 40.7821 15.8074 38.1067 12.4551 37.1844C15.8074 36.2664 18.4289 33.5954 19.3335 30.1765C20.2345 33.5979 22.8489 36.2707 26.2012 37.1956Z"
        stroke="#392403"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const ProductionIcon = () => (
  <svg
    width="137"
    height="143"
    viewBox="0 0 137 143"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 1324">
      <path
        id="path18"
        d="M134.157 75.4275C134.157 112.197 104.35 142.004 67.5764 142.004C30.8112 142.004 1 112.197 1 75.4275C1 38.6542 30.8112 8.84703 67.5764 8.84703C104.35 8.84703 134.157 38.6542 134.157 75.4275Z"
        fill="#FFE3B9"
      />
      <g id="Clip path group">
        <mask
          id="mask0_1530_12441"
          maskUnits="userSpaceOnUse"
          x="48"
          y="0"
          width="70"
          height="34"
        >
          <g id="clipPath26">
            <path
              id="path24"
              d="M63.6668 13.3523C67.7993 13.7662 69.3335 19.6147 73.838 20.0349C77.3455 20.3609 79.1389 17.0729 84.5694 11.6299C92.0525 4.13008 96.3563 -0.182102 101.709 0.00392914C109.989 0.290295 119.086 11.2892 116.897 15.0433C114.815 18.6156 103.403 14.0902 99.7572 18.7494C96.5779 22.8149 102.834 29.3699 99.8972 31.5313C96.6197 33.9413 88.104 26.3056 79.5528 28.6906C75.4622 29.8319 75.4203 32.1332 71.6098 32.8439C65.9515 33.9016 53.9074 18.6406 53.9074 33.9727H48.5605C48.5605 17.5955 61.0896 13.0952 63.6668 13.3523Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask0_1530_12441)">
          <g id="g22">
            <g id="g28">
              <path
                id="path36"
                d="M63.6653 13.3605C67.7988 13.7722 69.335 19.6201 73.8367 20.0398C77.3447 20.3684 79.1382 17.0782 84.5704 11.6342C92.0534 4.1353 96.3572 -0.176395 101.71 0.00968933C109.989 0.294762 119.088 11.2937 116.898 15.0471C114.815 18.6224 103.405 14.0969 99.7583 18.757C96.5789 22.8192 102.835 29.3758 99.8968 31.5376C96.6185 33.9449 88.106 26.3113 79.5539 28.6948C75.464 29.8351 75.4204 32.1394 71.6116 32.8481C65.9538 33.9092 53.9096 18.6461 53.9096 33.9805H48.5605C48.5605 17.6009 61.0917 13.0991 63.6653 13.3605Z"
                fill="#51708D"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="path40"
        d="M71.1125 16.213C72.2742 17.298 75.9478 17.272 78.4486 15.3435C80.9532 13.4186 81.3417 10.3196 80.18 9.23452C79.0184 8.14576 76.7432 9.47977 74.2386 11.4083C71.734 13.3369 69.9472 15.1242 71.1125 16.213Z"
        fill="#A2C4E2"
      />
      <path
        id="path44"
        d="M119.065 12.0527C118.918 10.6641 115.831 8.67096 112.268 8.62806C108.71 8.58515 106.029 10.512 106.176 11.8967C106.322 13.2852 109.236 13.609 112.794 13.6519C116.356 13.6948 119.211 13.4412 119.065 12.0527Z"
        fill="#A2C4E2"
      />
      <path
        id="path48"
        d="M114.8 53.8889L21 72.457V100.242H114.8V53.8889Z"
        fill="#A2C4E2"
      />
      <g id="Clip path group_2">
        <mask
          id="mask1_1530_12441"
          maskUnits="userSpaceOnUse"
          x="21"
          y="100"
          width="94"
          height="32"
        >
          <g id="clipPath56">
            <path
              id="path54"
              d="M21.0762 100.163V131.5H114.893V100.163H21.0762Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask1_1530_12441)">
          <g id="g52">
            <g id="g58">
              <path
                id="path66"
                d="M21.0762 100.162V131.5H114.893V100.162H21.0762Z"
                fill="#A2C4E2"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="path70"
        d="M41.2309 90.1836H29.6426V78.3766H41.2309V90.1836Z"
        fill="#7091B0"
      />
      <path
        id="path74"
        d="M41.2309 105.926H29.6426V94.3375H41.2309V105.926Z"
        fill="#7091B0"
      />
      <path
        id="path78"
        d="M41.2309 121.887H29.6426V110.298H41.2309V121.887Z"
        fill="#7091B0"
      />
      <path
        id="path82"
        d="M114.478 68.9079V53.8879L20.6777 72.4253V131.508H114.478V81.1361"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path86"
        d="M66.0324 103.957H79.8967C81.0213 103.957 81.9291 103.049 81.9291 101.925V88.0603C81.9291 86.9395 81.0213 86.0279 79.8967 86.0279H66.0324C64.9079 86.0279 64 86.9395 64 88.0603V101.925C64 103.049 64.9079 103.957 66.0324 103.957Z"
        fill="#B4DBAD"
      />
      <path
        id="path90"
        d="M65.5686 103.957H79.4306C80.5514 103.957 81.4623 103.046 81.4623 101.922V88.0596C81.4623 86.9388 80.5514 86.0279 79.4306 86.0279H65.5686C64.4441 86.0279 63.5332 86.9388 63.5332 88.0596V101.922C63.5332 103.046 64.4441 103.957 65.5686 103.957Z"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path94"
        d="M112.169 103.957H126.034C127.155 103.957 128.064 103.049 128.064 101.923V88.062C128.064 86.9404 127.155 86.0279 126.034 86.0279H112.169C111.047 86.0279 110.135 86.9404 110.135 88.062V101.923C110.135 103.049 111.047 103.957 112.169 103.957Z"
        fill="#B4DBAD"
      />
      <path
        id="path98"
        d="M111.923 103.957H125.783C126.908 103.957 127.816 103.046 127.816 101.921V88.0604C127.816 86.9393 126.908 86.0279 125.783 86.0279H111.923C110.798 86.0279 109.887 86.9393 109.887 88.0604V101.921C109.887 103.046 110.798 103.957 111.923 103.957Z"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path102"
        d="M89.1851 103.957H102.881C103.992 103.957 104.888 103.046 104.888 101.921V88.0636C104.888 86.9391 103.992 86.0279 102.881 86.0279H89.1851C88.078 86.0279 87.1777 86.9391 87.1777 88.0636V101.921C87.1777 103.046 88.078 103.957 89.1851 103.957Z"
        fill="#B4DBAD"
      />
      <path
        id="path106"
        d="M88.7439 103.957H102.607C103.728 103.957 104.638 103.047 104.638 101.922V88.0589C104.638 86.9383 103.728 86.0279 102.607 86.0279H88.7439C87.6194 86.0279 86.709 86.9383 86.709 88.0589V101.922C86.709 103.047 87.6194 103.957 88.7439 103.957Z"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path110"
        d="M133.938 45.0402C128.98 46.3729 125.103 50.2412 123.763 55.1992C122.434 50.2372 118.562 46.3648 113.604 45.024C118.562 43.6913 122.438 39.823 123.779 34.865C125.107 39.823 128.98 43.6994 133.938 45.0402Z"
        fill="white"
      />
      <path
        id="path114"
        d="M110.543 38.8019C107.343 39.6632 104.841 42.157 103.979 45.3594C103.118 42.157 100.623 39.6553 97.4238 38.7941C100.623 37.9328 103.126 35.439 103.987 32.2405C104.845 35.439 107.343 37.9406 110.543 38.8019Z"
        fill="white"
      />
      <path
        id="path118"
        d="M135.907 45.0423C130.945 46.3708 127.072 50.2426 125.731 55.1992C124.402 50.2386 120.53 46.3627 115.572 45.026C120.53 43.6934 124.407 39.8256 125.748 34.865C127.076 39.8256 130.949 43.7015 135.907 45.0423Z"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path122"
        d="M112.728 38.8058C109.526 39.6624 107.027 42.1612 106.163 45.3594C105.302 42.1612 102.808 39.6584 99.6094 38.7941C102.808 37.9375 105.31 35.4387 106.175 32.2405C107.031 35.4387 109.53 37.9415 112.728 38.8058Z"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path126"
        d="M72.498 131.508H69.3688L68.125 112.485H71.2542L72.498 131.508Z"
        fill="#B3D4F3"
      />
      <path
        id="path130"
        d="M98.5174 131.508H95.2326L93.9258 112.485H97.2106L98.5174 131.508Z"
        fill="#B3D4F3"
      />
      <path
        id="path134"
        d="M124.318 131.508H121.187L119.945 112.485H123.072L124.318 131.508Z"
        fill="#B3D4F3"
      />
      <path
        id="path138"
        d="M69.3688 131.508L68.125 112.485H71.2542L72.498 131.508"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path142"
        d="M95.2326 131.508L93.9258 112.485H97.2106L98.5174 131.508"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path146"
        d="M121.187 131.508L119.945 112.485H123.072L124.318 131.508"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path150"
        d="M126.251 112.484H63.2469C60.9019 112.484 59 110.573 59 108.221C59 105.869 60.9019 103.957 63.2469 103.957H126.251C128.596 103.957 130.498 105.869 130.498 108.221C130.498 110.573 128.596 112.484 126.251 112.484Z"
        fill="#B8DBE6"
      />
      <path
        id="path154"
        d="M126.203 112.484H63.3968C61.0584 112.484 59.1602 110.574 59.1602 108.217C59.1602 105.867 61.0584 103.957 63.3968 103.957H126.203C128.541 103.957 130.439 105.867 130.439 108.217C130.439 110.574 128.541 112.484 126.203 112.484Z"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path158"
        d="M123.443 108.218C123.443 109.609 122.317 110.734 120.931 110.734C119.54 110.734 118.414 109.609 118.414 108.218C118.414 106.831 119.54 105.705 120.931 105.705C122.317 105.705 123.443 106.831 123.443 108.218Z"
        fill="white"
      />
      <path
        id="path162"
        d="M97.2048 108.22C97.2048 109.61 96.1295 110.734 94.7997 110.734C93.4736 110.734 92.3945 109.61 92.3945 108.22C92.3945 106.834 93.4736 105.705 94.7997 105.705C96.1295 105.705 97.2048 106.834 97.2048 108.22Z"
        fill="white"
      />
      <path
        id="path166"
        d="M70.9685 108.222C70.9685 109.611 69.8906 110.734 68.5651 110.734C67.236 110.734 66.1582 109.611 66.1582 108.222C66.1582 106.832 67.236 105.705 68.5651 105.705C69.8906 105.705 70.9685 106.832 70.9685 108.222Z"
        fill="white"
      />
      <path
        id="path170"
        d="M123.443 108.218C123.443 109.609 122.317 110.734 120.931 110.734C119.54 110.734 118.414 109.609 118.414 108.218C118.414 106.831 119.54 105.705 120.931 105.705C122.317 105.705 123.443 106.831 123.443 108.218Z"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path174"
        d="M97.2048 108.22C97.2048 109.61 96.1295 110.734 94.7997 110.734C93.4736 110.734 92.3945 109.61 92.3945 108.22C92.3945 106.834 93.4736 105.705 94.7997 105.705C96.1295 105.705 97.2048 106.834 97.2048 108.22Z"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path178"
        d="M70.9685 108.222C70.9685 109.611 69.8906 110.734 68.5651 110.734C67.236 110.734 66.1582 109.611 66.1582 108.222C66.1582 106.832 67.236 105.705 68.5651 105.705C69.8906 105.705 70.9685 106.832 70.9685 108.222Z"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path182"
        d="M9.30861 131.508H1"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path186"
        d="M134.157 131.508H13.9004"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path190"
        d="M31.73 37.2696L29.6426 70.7227L34.2342 69.8124V37.2696H31.73Z"
        fill="#B8DBE6"
      />
      <path
        id="path194"
        d="M37.003 37.273H34.2344V69.8516L39.0446 68.8729L37.003 37.273Z"
        fill="white"
      />
      <path
        id="path198"
        d="M39.0444 68.8339L29.6426 70.7227L31.7063 37.2696H36.9807L39.0444 68.8339Z"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path202"
        d="M48.565 33.9921L46.4785 67.2266L51.0701 66.3235V33.9921H48.565Z"
        fill="#B8DBE6"
      />
      <path
        id="path206"
        d="M53.967 33.9917H51.0703V66.3516L56.0992 65.3827L53.967 33.9917Z"
        fill="white"
      />
      <path
        id="path210"
        d="M56.099 65.3516L46.4785 67.2266L48.5915 33.9921H53.9897L56.099 65.3516Z"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path214"
        d="M51.9453 71.597L58.2119 78.5938L64.4786 71.597L70.749 78.5938L77.0157 71.597L83.2823 78.5938L89.5527 71.597"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path218"
        d="M51.9453 71.5977H89.5527"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path222"
        d="M89.1152 71.597L95.3494 78.5938L101.58 71.597L107.81 78.5938L114.04 71.597L120.274 78.5938L126.504 71.597"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path226"
        d="M89.1152 71.5977H126.504"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path230"
        d="M120.162 78.5938H58.2852"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const RawMaterialsIcon = () => (
  <svg
    width="172"
    height="137"
    viewBox="0 0 172 137"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 1323">
      <path
        id="path740"
        d="M155.368 68.3701C155.368 106.131 124.758 136.738 86.9994 136.738C49.2406 136.738 18.6309 106.131 18.6309 68.3701C18.6309 30.6095 49.2406 0.00184631 86.9994 0.00184631C124.758 0.00184631 155.368 30.6095 155.368 68.3701Z"
        fill="#C9ECF6"
      />
      <path
        id="path744"
        d="M106.301 25.3469C101.192 26.7181 97.1996 30.7056 95.8207 35.8125C94.4492 30.7021 90.462 26.7111 85.3555 25.3329C90.4644 23.9618 94.4572 19.9742 95.8361 14.8673C97.2076 19.9777 101.194 23.9687 106.301 25.3469Z"
        fill="white"
      />
      <path
        id="path748"
        d="M82.3935 18.9037C79.1039 19.7859 76.5327 22.355 75.6449 25.6445C74.7617 22.355 72.1948 19.7824 68.9062 18.8932C72.1958 18.0111 74.767 15.4455 75.6548 12.1559C76.538 15.4455 79.1053 18.0181 82.3935 18.9037Z"
        fill="white"
      />
      <path
        id="path752"
        d="M108.449 25.3469C103.341 26.7181 99.348 30.7056 97.9691 35.8125C96.5976 30.7056 92.6108 26.7111 87.5039 25.3329C92.6129 23.9618 96.6057 19.9742 97.9845 14.8673C99.3561 19.9777 103.343 23.9687 108.449 25.3469Z"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path756"
        d="M84.54 18.9037C81.2504 19.7859 78.6792 22.355 77.7914 25.6445C76.9082 22.355 74.3412 19.7824 71.0527 18.8932C74.3423 18.0111 76.9132 15.4455 77.8013 12.1559C78.6845 15.4455 81.2518 18.0181 84.54 18.9037Z"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="Clip path group">
        <mask
          id="mask0_1525_8948"
          maskUnits="userSpaceOnUse"
          x="118"
          y="48"
          width="53"
          height="46"
        >
          <g id="clipPath764">
            <path
              id="path762"
              d="M118.537 71.3673C118.564 74.8244 121.38 76.306 123.479 79.1103C125.201 81.4121 125.358 87.4823 128.119 89.0798C130.453 90.4304 134.227 86.7028 137.093 87.3943C139.665 88.0127 142.087 93.3399 144.937 93.3163C147.789 93.2927 150.128 87.9268 152.691 87.2654C155.545 86.5289 159.376 90.1921 161.69 88.8028C164.427 87.1602 164.491 81.09 166.176 78.7603C168.232 75.9195 171.027 74.3928 171 70.9357C170.973 67.4766 168.156 65.9971 166.059 63.1907C164.336 60.891 164.178 54.8208 161.419 53.2232C159.084 51.8705 155.287 52.5104 152.42 51.8211C149.849 51.2006 147.446 48.3362 144.594 48.3598C141.743 48.3834 139.384 51.2865 136.822 51.95C133.967 52.6865 130.161 52.1089 127.847 53.4981C125.111 55.1407 125.047 61.2131 123.36 63.5429C121.305 66.3815 118.511 67.9081 118.537 71.3673Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask0_1525_8948)">
          <g id="g760">
            <g id="g766">
              <path
                id="path774"
                d="M118.535 71.3653C118.562 74.8224 121.378 76.304 123.477 79.1092C125.199 81.4107 125.356 87.482 128.117 89.0789C130.451 90.4288 134.225 86.7017 137.091 87.3931C139.663 88.0121 142.085 93.3394 144.935 93.3163C147.787 93.2933 150.126 87.9265 152.689 87.2647C155.543 86.5272 159.374 90.1917 161.688 88.8023C164.425 87.1593 164.489 81.088 166.174 78.7602C168.23 75.9188 171.025 74.391 170.998 70.9339C170.971 67.4768 168.154 65.9952 166.056 63.19C164.333 60.8918 164.176 54.8205 161.417 53.2236C159.082 51.8704 155.285 52.5091 152.418 51.821C149.847 51.1987 147.444 48.3342 144.591 48.3606C141.741 48.3836 139.382 51.2843 136.82 51.9494C133.965 52.6869 130.159 52.1074 127.845 53.4969C125.109 55.1398 125.045 61.2112 123.358 63.5423C121.303 66.3804 118.509 67.9081 118.535 71.3653Z"
                fill="#79BBAF"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Clip path group_2">
        <mask
          id="mask1_1525_8948"
          maskUnits="userSpaceOnUse"
          x="125"
          y="48"
          width="40"
          height="46"
        >
          <g id="clipPath782">
            <path
              id="path780"
              d="M125.008 71.3134C125.035 74.7704 128.245 76.2498 129.738 79.0605C130.963 81.3667 131.09 87.4369 133.048 89.0409C134.705 90.3979 137.367 86.6811 139.398 87.3789C141.221 88.0037 142.949 93.3374 144.968 93.3203C146.988 93.3052 148.631 87.9458 150.443 87.2909C152.464 86.5608 155.184 90.2369 156.82 88.854C158.753 87.2178 158.783 81.1455 159.97 78.8201C161.42 75.9857 164.604 74.4569 164.578 70.9998C164.55 67.5428 161.34 66.0634 159.848 63.2527C158.622 60.9465 158.495 54.8763 156.537 53.2723C154.881 51.9153 152.193 52.5444 150.162 51.8465C148.339 51.2196 146.632 48.3487 144.611 48.3659C142.593 48.3809 140.931 51.2797 139.117 51.9346C137.098 52.6625 134.401 52.0763 132.766 53.4592C130.833 55.0953 130.802 61.1677 129.614 63.4931C128.166 66.3253 124.981 67.8563 125.008 71.3134Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask1_1525_8948)">
          <g id="g778">
            <g id="g784">
              <path
                id="path792"
                d="M125.008 71.3141C125.035 74.7711 128.245 76.2494 129.738 79.061C130.963 81.3657 131.09 87.4368 133.048 89.0402C134.705 90.3967 137.368 86.6796 139.398 87.3776C141.221 88.0031 142.949 93.3367 144.967 93.3203C146.988 93.3038 148.631 87.9438 150.443 87.2887C152.463 86.561 155.184 90.2353 156.82 88.8525C158.753 87.2162 158.783 81.1451 159.97 78.8207C161.42 75.986 164.604 74.455 164.578 70.998C164.55 67.541 161.34 66.0628 159.848 63.2511C158.622 60.9464 158.495 54.8753 156.537 53.2719C154.881 51.9155 152.193 52.5443 150.162 51.8463C148.339 51.2175 146.632 48.3465 144.611 48.3663C142.593 48.3795 140.931 51.28 139.117 51.9352C137.098 52.6628 134.401 52.0768 132.766 53.4596C130.833 55.0959 130.803 61.167 129.614 63.4914C128.166 66.3262 124.981 67.8571 125.008 71.3141Z"
                fill="#316F63"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="path796"
        d="M148.593 60.5378C149.377 60.644 150.169 60.7308 150.965 60.792C150.497 68.08 149.54 75.3809 148.09 82.6335C151.262 80.3103 154.158 77.7362 156.761 74.9722C157.495 75.5289 158.247 76.0694 159.015 76.5939C155.642 80.2975 151.771 83.6921 147.446 86.6362C147.633 91.5496 148.677 120.991 148.863 125.905C147.961 125.95 146.413 125.979 145.511 125.988L144.932 81.932C146.63 74.8532 147.85 67.7003 148.593 60.5378Z"
        fill="#8F5409"
      />
      <path
        id="path800"
        d="M130.734 76.8201C131.494 76.2811 132.237 75.7295 132.963 75.1621C135.607 77.8824 138.543 80.4135 141.751 82.6831C140.871 79.0014 140.128 75.3008 139.525 71.5939C140.42 71.4931 141.309 71.3701 142.191 71.222C142.936 74.9257 143.823 78.6137 144.847 82.2764C144.875 82.163 144.903 82.0463 144.931 81.9329L145.511 125.99C144.489 126.003 142.82 125.996 141.798 125.968C141.901 121.066 142.44 91.6319 142.543 86.7304C138.139 83.843 134.187 80.4923 130.734 76.8201Z"
        fill="#EEA774"
      />
      <path
        id="path804"
        d="M141.798 125.969C141.901 121.068 142.44 91.6327 142.543 86.7315C138.139 83.8445 134.187 80.4929 130.734 76.8201"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path808"
        d="M159.015 76.5964C155.641 80.2988 151.77 83.6956 147.445 86.6401C147.632 91.5527 148.675 120.994 148.862 125.91"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path812"
        d="M148.09 82.6328C151.261 80.3141 154.158 77.7358 156.76 74.9727"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path816"
        d="M144.848 82.2734C146.589 75.0852 147.839 67.8165 148.592 60.5381"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path820"
        d="M141.751 82.6836C140.87 79.0046 140.128 75.3035 139.525 71.5962"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path824"
        d="M147.603 92.0287C149.39 90.3891 151.043 87.7222 152.802 87.2711C155.66 86.5336 159.495 90.2014 161.809 88.812C164.547 87.169 164.612 81.0976 166.299 78.7698C168.354 75.9317 171.152 74.404 171.124 70.9469C171.096 67.4864 168.277 66.0048 166.175 63.2029C164.451 60.8982 164.292 54.8301 161.528 53.23C159.19 51.88 155.389 52.5155 152.521 51.824C149.946 51.2051 147.541 48.3406 144.685 48.3636C141.832 48.3867 139.471 51.2874 136.907 51.9492C134.049 52.6867 130.239 52.1105 127.923 53.4966C125.186 55.1396 125.122 61.211 123.435 63.5421C121.378 66.3802 118.582 67.9046 118.61 71.3617C118.637 74.8189 121.457 76.3005 123.559 79.109C125.282 81.4104 125.442 87.4818 128.206 89.0786C130.543 90.4319 134.319 86.7015 137.188 87.3929C138.958 87.8209 140.657 90.4714 142.474 92.0781"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="Clip path group_3">
        <mask
          id="mask2_1525_8948"
          maskUnits="userSpaceOnUse"
          x="59"
          y="48"
          width="56"
          height="46"
        >
          <g id="clipPath832">
            <path
              id="path830"
              d="M59.7678 71.3673C59.7953 74.8244 62.7196 76.306 64.8981 79.1103C66.6857 81.4121 66.8491 87.4823 69.7148 89.0798C72.1384 90.4304 76.0562 86.7028 79.031 87.3943C81.7015 88.0127 84.215 93.3399 87.1756 93.3163C90.136 93.2927 92.565 87.9268 95.2254 87.2654C98.1888 86.5289 102.165 90.1921 104.567 88.8028C107.407 87.1602 107.474 81.09 109.225 78.7603C111.359 75.9195 114.26 74.3928 114.232 70.9357C114.205 67.4766 111.28 65.9971 109.102 63.1907C107.314 60.891 107.151 54.8208 104.285 53.2232C101.861 51.8705 97.9191 52.5104 94.9443 51.8211C92.274 51.2006 89.7798 48.3362 86.8192 48.3598C83.8588 48.3834 81.4103 51.2865 78.7499 51.95C75.7865 52.6865 71.8346 52.1089 69.4327 53.4981C66.5927 55.1407 66.5255 61.2131 64.7747 63.5429C62.6408 66.3815 59.7403 67.9081 59.7678 71.3673Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask2_1525_8948)">
          <g id="g828">
            <g id="g834">
              <path
                id="path842"
                d="M59.7639 71.3653C59.7912 74.8224 62.7156 76.304 64.8942 79.1092C66.6817 81.4107 66.845 87.482 69.7108 89.0789C72.1344 90.4288 76.0522 86.7017 79.0269 87.3931C81.6975 88.0121 84.211 93.3394 87.1716 93.3163C90.1319 93.2933 92.5607 87.9265 95.2214 87.2647C98.1847 86.5272 102.161 90.1917 104.563 88.8023C107.403 87.1593 107.47 81.088 109.221 78.7602C111.355 75.9188 114.255 74.391 114.228 70.9339C114.201 67.4768 111.276 65.9952 109.098 63.19C107.31 60.8918 107.147 54.8205 104.281 53.2236C101.857 51.8704 97.915 52.5091 94.9402 51.821C92.27 51.1987 89.7756 48.3342 86.815 48.3606C83.8547 48.3836 81.4064 51.2843 78.7458 51.9494C75.7825 52.6869 71.8305 52.1074 69.4287 53.4969C66.5885 55.1398 66.5214 61.2112 64.7708 63.5423C62.6369 66.3804 59.7362 67.9081 59.7639 71.3653Z"
                fill="#46887C"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Clip path group_4">
        <mask
          id="mask3_1525_8948"
          maskUnits="userSpaceOnUse"
          x="66"
          y="48"
          width="40"
          height="46"
        >
          <g id="clipPath850">
            <path
              id="path848"
              d="M66.2424 71.3134C66.2698 74.7704 69.4789 76.2498 70.9721 79.0605C72.197 81.3667 72.3237 87.4369 74.2824 89.0409C75.939 90.3979 78.6018 86.6811 80.6324 87.3789C82.4554 88.0037 84.1835 93.3374 86.2026 93.3203C88.2218 93.3052 89.8651 87.9458 91.678 87.2909C93.6975 86.5608 96.4189 90.2369 98.0536 88.854C99.9865 87.2178 100.017 81.1455 101.205 78.8201C102.654 75.9857 105.839 74.4569 105.811 70.9998C105.784 67.5428 102.575 66.0634 101.082 63.2527C99.857 60.9465 99.7301 54.8763 97.7714 53.2723C96.115 51.9153 93.4278 52.5444 91.3969 51.8465C89.5739 51.2196 87.8656 48.3487 85.8463 48.3659C83.8271 48.3809 82.1643 51.2797 80.3516 51.9346C78.3321 52.6625 75.635 52.0763 74.0003 53.4592C72.0674 55.0953 72.0369 61.1677 70.8486 63.4931C69.4003 66.3253 66.2149 67.8563 66.2424 71.3134Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask3_1525_8948)">
          <g id="g846">
            <g id="g852">
              <path
                id="path860"
                d="M66.2424 71.3141C66.2697 74.7711 69.4788 76.2494 70.9718 79.061C72.1969 81.3657 72.3237 87.4368 74.2823 89.0402C75.9387 90.3967 78.6016 86.6796 80.6323 87.3776C82.4553 88.0031 84.1831 93.3367 86.2023 93.3203C88.2216 93.3038 89.8648 87.9438 91.6779 87.2887C93.6971 86.561 96.4185 90.2353 98.0532 88.8525C99.9862 87.2162 100.017 81.1451 101.205 78.8207C102.654 75.986 105.839 74.455 105.811 70.998C105.784 67.541 102.575 66.0628 101.082 63.2511C99.8568 60.9464 99.7297 54.8753 97.7711 53.2719C96.1147 51.9155 93.4274 52.5443 91.3967 51.8463C89.5737 51.2175 87.8653 48.3465 85.8461 48.3663C83.8269 48.3795 82.1639 51.28 80.3515 51.9352C78.3319 52.6628 75.6348 52.0768 74.0002 53.4596C72.0672 55.0959 72.0366 61.167 70.8484 63.4914C69.4001 66.3262 66.2147 67.8571 66.2424 71.3141Z"
                fill="#316F63"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="path864"
        d="M89.8242 60.5378C90.6096 60.644 91.4008 60.7308 92.1975 60.792C91.731 68.08 90.7724 75.3809 89.3228 82.6335C92.4945 80.3103 95.3914 77.7362 97.9925 74.9722C98.7278 75.5289 99.4794 76.0694 100.247 76.5939C96.8744 80.2975 93.0038 83.6921 88.678 86.6362C88.8653 91.5496 89.9091 120.991 90.0961 125.905C89.1945 125.95 87.6468 125.979 86.7442 125.988L86.1641 81.932C87.862 74.8532 89.0835 67.7003 89.8242 60.5378Z"
        fill="#8F5409"
      />
      <path
        id="path868"
        d="M71.9668 76.8201C72.7261 76.2811 73.4694 75.7295 74.1957 75.1621C76.8393 77.8824 79.7755 80.4135 82.9825 82.6831C82.1024 79.0014 81.3604 75.3008 80.758 71.5939C81.6526 71.4931 82.5409 71.3701 83.4228 71.222C84.1677 74.9257 85.0547 78.6137 86.0807 82.2764C86.1084 82.163 86.1355 82.0463 86.1633 81.9329L86.7436 125.99C85.7213 126.003 84.0532 125.996 83.031 125.968C83.1347 121.066 83.6725 91.6319 83.7762 86.7304C79.3714 83.843 75.4196 80.4923 71.9668 76.8201Z"
        fill="#EEA774"
      />
      <path
        id="path872"
        d="M83.0312 125.969C83.135 121.068 83.6725 91.6327 83.7763 86.7315C79.3715 83.8445 75.4194 80.4929 71.9668 76.8201"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path876"
        d="M100.245 76.5964C96.8723 80.2988 93.0014 83.6956 88.6758 86.6401C88.8629 91.5527 89.9069 120.994 90.0941 125.91"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path880"
        d="M89.3223 82.6328C92.4939 80.3141 95.3906 77.7358 97.9918 74.9727"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path884"
        d="M86.082 82.2734C87.8234 75.0852 89.0719 67.8165 89.8248 60.5381"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path888"
        d="M82.9826 82.6836C82.1022 79.0046 81.3597 75.3035 80.7578 71.5962"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path892"
        d="M88.8351 92.0287C90.6216 90.3891 92.2754 87.7222 94.0346 87.2711C96.8918 86.5336 100.727 90.2014 103.043 88.812C105.781 87.169 105.843 81.0976 107.531 78.7698C109.587 75.9317 112.384 74.404 112.356 70.9469C112.329 67.4864 109.509 66.0048 107.407 63.2029C105.683 60.8982 105.524 54.8301 102.76 53.23C100.423 51.88 96.6221 52.5155 93.7537 51.824C91.1787 51.2051 88.7728 48.3406 85.9186 48.3636C83.064 48.3867 80.7042 51.2874 78.1394 51.9492C75.2818 52.6867 71.4711 52.1105 69.1558 53.4966C66.4181 55.1396 66.3549 61.211 64.6675 63.5421C62.6106 66.3802 59.8147 67.9046 59.842 71.3617C59.8693 74.8189 62.6893 76.3005 64.7909 79.109C66.5149 81.4104 66.6746 87.4818 69.438 89.0786C71.7753 90.4319 75.5515 86.7015 78.4202 87.3929C80.1903 87.8209 81.8895 90.4714 83.706 92.0781"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="Clip path group_5">
        <mask
          id="mask4_1525_8948"
          maskUnits="userSpaceOnUse"
          x="1"
          y="48"
          width="55"
          height="46"
        >
          <g id="clipPath900">
            <path
              id="path898"
              d="M1.00019 71.3673C1.02746 74.8244 3.95178 76.306 6.13057 79.1103C7.91792 81.4121 8.08154 87.4823 10.9472 89.0798C13.3708 90.4304 17.2886 86.7028 20.2632 87.3943C22.9337 88.0127 25.4475 93.3399 28.4079 93.3163C31.3685 93.2927 33.7974 87.9268 36.4578 87.2654C39.4212 86.5289 43.3977 90.1921 45.7995 88.8028C48.6395 87.1602 48.7067 81.09 50.4575 78.7603C52.5915 75.9195 55.4917 74.3928 55.4644 70.9357C55.437 67.4766 52.5126 65.9971 50.3341 63.1907C48.5465 60.891 48.3831 54.8208 45.5172 53.2232C43.0938 51.8705 39.1515 52.5104 36.1767 51.8211C33.5062 51.2006 31.012 48.3362 28.0516 48.3598C25.091 48.3834 22.6425 51.2865 19.9823 51.95C17.019 52.6865 13.0668 52.1089 10.6651 53.4981C7.82495 55.1407 7.75774 61.2131 6.00711 63.5429C3.87319 66.3815 0.972709 67.9081 1.00019 71.3673Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask4_1525_8948)">
          <g id="g896">
            <g id="g902">
              <path
                id="path910"
                d="M1.00019 71.3653C1.02752 74.8224 3.95192 76.304 6.13056 79.1092C7.91806 81.4107 8.0817 87.482 10.9475 89.0789C13.3711 90.4288 17.2888 86.7017 20.2633 87.3931C22.9338 88.0121 25.4476 93.3394 28.4079 93.3163C31.3685 93.2933 33.7974 87.9265 36.4577 87.2647C39.4213 86.5272 43.3977 90.1917 45.7995 88.8023C48.6393 87.1593 48.7068 81.088 50.4574 78.7602C52.5913 75.9188 55.4917 74.391 55.4643 70.9339C55.437 67.4768 52.5126 65.9952 50.334 63.19C48.5465 60.8918 48.3832 54.8205 45.517 53.2236C43.0938 51.8704 39.1517 52.5091 36.1769 51.821C33.5063 51.1987 31.012 48.3342 28.0517 48.3606C25.0911 48.3836 22.6424 51.2843 19.9824 51.9494C17.0192 52.6869 13.0669 52.1074 10.6653 53.4969C7.82521 55.1398 7.75771 61.2112 6.00709 63.5423C3.87323 66.3804 0.972864 67.9081 1.00019 71.3653Z"
                fill="#8ACCBF"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Clip path group_6">
        <mask
          id="mask5_1525_8948"
          maskUnits="userSpaceOnUse"
          x="7"
          y="48"
          width="41"
          height="46"
        >
          <g id="clipPath918">
            <path
              id="path916"
              d="M7.47478 71.3134C7.50227 74.7704 10.7115 76.2498 12.2045 79.0605C13.4295 81.3667 13.5564 87.4369 15.5151 89.0409C17.1715 90.3979 19.8342 86.6811 21.8651 87.3789C23.6881 88.0037 25.416 93.3374 27.4352 93.3203C29.4545 93.3052 31.0975 87.9458 32.9104 87.2909C34.9299 86.5608 37.6513 90.2369 39.2862 88.854C41.2191 87.2178 41.2496 81.1455 42.4379 78.8201C43.8862 75.9857 47.0716 74.4569 47.0441 70.9998C47.0166 67.5428 43.8076 66.0634 42.3144 63.2527C41.0894 60.9465 40.9625 54.8763 39.004 53.2723C37.3475 51.9153 34.6602 52.5444 32.6296 51.8465C30.8066 51.2196 29.098 48.3487 27.0788 48.3659C25.0595 48.3809 23.3969 51.2797 21.584 51.9346C19.5645 52.6625 16.8676 52.0763 15.2329 53.4592C13.3 55.0953 13.2693 61.1677 12.081 63.4931C10.6327 66.3253 7.44751 67.8563 7.47478 71.3134Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask5_1525_8948)">
          <g id="g914">
            <g id="g920">
              <path
                id="path928"
                d="M7.47283 71.3141C7.50049 74.7711 10.7096 76.2494 12.2026 79.061C13.4277 81.3657 13.5545 87.4368 15.5131 89.0402C17.1695 90.3967 19.8324 86.6796 21.8631 87.3776C23.6861 88.0031 25.4139 93.3367 27.4331 93.3203C29.4527 93.3038 31.0956 87.9438 32.9083 87.2887C34.9279 86.561 37.6494 90.2353 39.2843 88.8525C41.2173 87.2162 41.2476 81.1451 42.4358 78.8207C43.8841 75.986 47.0698 74.455 47.0421 70.998C47.0148 67.541 43.8057 66.0628 42.3123 63.2511C41.0876 60.9464 40.9605 54.8753 39.0022 53.2719C37.3455 51.9155 34.6582 52.5443 32.6275 51.8463C30.8045 51.2175 29.0961 48.3465 27.0769 48.3663C25.0577 48.3795 23.395 51.28 21.5819 51.9352C19.5627 52.6628 16.8656 52.0768 15.231 53.4596C13.298 55.0959 13.2674 61.167 12.0792 63.4914C10.6309 66.3262 7.4455 67.8571 7.47283 71.3141Z"
                fill="#46887C"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="path932"
        d="M31.0572 60.5378C31.8423 60.644 32.6336 60.7308 33.4306 60.792C32.9637 68.08 32.0051 75.3809 30.5559 82.6335C33.7276 80.3103 36.6241 77.7362 39.2253 74.9722C39.9605 75.5289 40.7121 76.0694 41.4802 76.5939C38.1071 80.2975 34.2366 83.6921 29.9108 86.6362C30.0977 91.5496 31.1422 120.991 31.3291 125.905C30.4272 125.95 28.8795 125.979 27.977 125.988L27.3965 81.932C29.0948 74.8532 30.3162 67.7003 31.0572 60.5378Z"
        fill="#8F5409"
      />
      <path
        id="path936"
        d="M13.1992 76.8201C13.9586 76.2811 14.7018 75.7295 15.4278 75.1621C18.0717 77.8824 21.0079 80.4135 24.2146 82.6831C23.3348 79.0014 22.5925 75.3008 21.9901 71.5939C22.885 71.4931 23.7736 71.3701 24.6552 71.222C25.4001 74.9257 26.2868 78.6137 27.3128 82.2764C27.3408 82.163 27.368 82.0463 27.3954 81.9329L27.9757 125.99C26.9535 126.003 25.2857 125.996 24.2634 125.968C24.3671 121.066 24.9049 91.6319 25.0086 86.7304C20.6038 83.843 16.6517 80.4923 13.1992 76.8201Z"
        fill="#EEA774"
      />
      <path
        id="path940"
        d="M24.2636 125.969C24.3671 121.068 24.9049 91.6327 25.0087 86.7315C20.6039 83.8445 16.6522 80.4929 13.1992 76.8201"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path944"
        d="M41.4774 76.5964C38.1047 80.2988 34.2338 83.6956 29.9082 86.6401C30.0954 91.5527 31.1396 120.994 31.3262 125.91"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path948"
        d="M30.5547 82.6328C33.7264 80.3141 36.6233 77.7358 39.2245 74.9727"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path952"
        d="M27.3145 82.2734C29.0559 75.0852 30.3043 67.8165 31.0572 60.5381"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path956"
        d="M24.2146 82.6836C23.3346 79.0046 22.5925 75.3035 21.9902 71.5962"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path960"
        d="M30.0678 92.0287C31.8543 90.3891 33.5078 87.7222 35.2673 87.2711C38.1245 86.5336 41.9596 90.2014 44.2749 88.812C47.013 87.169 47.0762 81.0976 48.7633 78.7698C50.8201 75.9317 53.6164 74.404 53.5887 70.9469C53.5614 67.4864 50.7414 66.0048 48.6398 63.2029C46.9158 60.8982 46.7565 54.8301 43.9928 53.23C41.6557 51.88 37.8546 52.5155 34.9861 51.824C32.4114 51.2051 30.0056 48.3406 27.151 48.3636C24.2964 48.3867 21.9363 51.2874 19.3718 51.9492C16.5146 52.6867 12.7038 52.1105 10.3882 53.4966C7.65052 55.1396 7.58763 61.211 5.8999 63.5421C3.84341 66.3802 1.04709 67.9046 1.07442 71.3617C1.10207 74.8189 3.9221 76.3005 6.02337 79.109C7.74765 81.4104 7.907 87.4818 10.6704 89.0786C13.0077 90.4319 16.7842 86.7015 19.6527 87.3929C21.4227 87.8209 23.122 90.4714 24.9388 92.0781"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="Clip path group_7">
        <mask
          id="mask6_1525_8948"
          maskUnits="userSpaceOnUse"
          x="20"
          y="35"
          width="61"
          height="53"
        >
          <g id="clipPath968">
            <path
              id="path966"
              d="M20.0295 62.1372C20.0602 66.1761 23.3339 67.9068 25.7728 71.1835C27.7738 73.8718 27.9567 80.9641 31.1648 82.8301C33.8779 84.4083 38.2638 80.0537 41.5938 80.8589C44.5831 81.5825 47.3971 87.8052 50.7114 87.7773C54.0254 87.7493 56.7445 81.4816 59.7227 80.7086C63.04 79.8476 67.4915 84.1291 70.1804 82.5058C73.3596 80.5883 73.4349 73.4939 75.3948 70.7734C77.7835 67.4559 81.0304 65.6715 80.9998 61.6326C80.9691 57.5937 77.6954 55.863 75.2565 52.5864C73.2555 49.898 73.0724 42.8057 69.8643 40.9398C67.1514 39.3616 62.7382 40.1088 59.4081 39.3036C56.4186 38.5799 53.6266 35.2324 50.3124 35.2604C46.9982 35.2883 44.2572 38.6787 41.2792 39.4517C37.9617 40.3149 33.5376 39.6407 30.8489 41.264C27.6697 43.1815 27.5944 50.2759 25.6345 52.9965C23.2458 56.3139 19.9989 58.0983 20.0295 62.1372Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask6_1525_8948)">
          <g id="g964">
            <g id="g970">
              <path
                id="path978"
                d="M20.0295 62.1367C20.0602 66.1774 23.3337 67.9077 25.7727 71.1828C27.7737 73.8709 27.9566 80.9641 31.1648 82.8293C33.8778 84.4078 38.2638 80.0534 41.5939 80.8595C44.5832 81.5847 47.3971 87.8042 50.7113 87.7773C54.0252 87.7503 56.7444 81.4835 59.7228 80.7077C63.0399 79.8477 67.4915 84.1312 70.1803 82.5055C73.3597 80.5897 73.435 73.4932 75.3947 70.7746C77.7835 67.4557 81.0305 65.6715 80.9998 61.6342C80.9691 57.5935 77.6956 55.8632 75.2567 52.5881C73.2557 49.9 73.0724 42.8068 69.8642 40.9416C67.1515 39.3631 62.738 40.1086 59.408 39.3024C56.4186 38.5807 53.6267 35.2314 50.3125 35.2617C46.9983 35.2887 44.2571 38.6784 41.2791 39.4508C37.9616 40.3143 33.5375 39.6397 30.849 41.2654C27.6696 43.1812 27.5943 50.2778 25.6343 52.9963C23.2458 56.3152 19.9988 58.0994 20.0295 62.1367Z"
                fill="#B4DBAD"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Clip path group_8">
        <mask
          id="mask7_1525_8948"
          maskUnits="userSpaceOnUse"
          x="27"
          y="35"
          width="47"
          height="53"
        >
          <g id="clipPath986">
            <path
              id="path984"
              d="M27.59 62.0764C27.622 66.1153 31.3711 67.8438 33.1153 71.1269C34.5464 73.8196 34.6944 80.9119 36.9827 82.7864C38.9175 84.371 42.0284 80.0293 44.4007 80.8431C46.5303 81.5754 48.5489 87.8044 50.9079 87.7851C53.2666 87.7658 55.1862 81.5066 57.304 80.7422C59.6632 79.8898 62.8424 84.1821 64.7521 82.5652C67.0102 80.6563 67.0458 73.5619 68.434 70.8456C70.126 67.5367 73.8469 65.7502 73.8149 61.7092C73.7829 57.6702 70.0341 55.9439 68.2897 52.6608C66.8588 49.966 66.7106 42.8737 64.4225 40.9991C62.4874 39.4145 59.348 40.1488 56.9757 39.335C54.8461 38.6028 52.8502 35.2489 50.4915 35.2682C48.1326 35.2875 46.1902 38.6716 44.0724 39.4381C41.7132 40.2906 38.5626 39.6035 36.6531 41.2203C34.3948 43.1313 34.3592 50.2237 32.971 52.9399C31.2792 56.2509 27.5581 58.0374 27.59 62.0764Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask7_1525_8948)">
          <g id="g982">
            <g id="g988">
              <path
                id="path996"
                d="M27.59 62.0747C27.6218 66.1153 31.3709 67.8421 33.1149 71.1272C34.5463 73.8186 34.6944 80.9115 36.9824 82.7867C38.9174 84.3719 42.0284 80.0278 44.4004 80.844C46.5303 81.5759 48.5489 87.8053 50.9078 87.7851C53.2664 87.7649 55.1861 81.5051 57.3039 80.7428C59.6631 79.8895 62.8422 84.183 64.7522 82.5641C67.0103 80.6551 67.0457 73.5623 68.4339 70.8438C70.126 67.5352 73.8468 65.751 73.8148 61.7105C73.7827 57.6699 70.0339 55.9431 68.2895 52.6614C66.8588 49.9666 66.7104 42.8737 64.4224 40.9985C62.4874 39.4133 59.3481 40.1486 56.9757 39.3357C54.8462 38.6038 52.8502 35.248 50.4913 35.2682C48.1324 35.2885 46.19 38.6713 44.0723 39.4369C41.713 40.2902 38.5626 39.6022 36.6529 41.2211C34.3945 43.1301 34.3591 50.2229 32.9709 52.938C31.2791 56.25 27.558 58.0376 27.59 62.0747Z"
                fill="#81A87A"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="path1000"
        d="M55.1415 49.4957C56.0585 49.6205 56.983 49.7191 57.9137 49.7947C57.3687 58.3072 56.249 66.8361 54.5557 75.3059C58.261 72.5921 61.645 69.586 64.6837 66.3564C65.5421 67.0037 66.4203 67.6344 67.3176 68.2488C63.3774 72.579 58.8553 76.5412 53.8024 79.981C54.0209 85.7239 55.2404 120.116 55.4589 125.858C54.4056 125.908 52.5976 125.944 51.5433 125.957L50.8652 74.4845C52.849 66.2184 54.2758 57.8636 55.1415 49.4957Z"
        fill="#8F5409"
      />
      <path
        id="path1004"
        d="M34.2793 68.5138C35.1665 67.8849 36.0345 67.2399 36.8826 66.5757C39.9712 69.7556 43.4014 72.711 47.1478 75.3615C46.1197 71.0648 45.2526 66.7425 44.5489 62.4073C45.5941 62.2918 46.6321 62.1474 47.6622 61.9741C48.5324 66.2997 49.5682 70.6092 50.7671 74.8866C50.7995 74.755 50.8312 74.6203 50.8633 74.4855L51.5414 125.959C50.347 125.972 48.3986 125.965 47.2043 125.927C47.3256 120.205 47.9539 85.816 48.0748 80.0914C42.9291 76.7188 38.3125 72.804 34.2793 68.5138Z"
        fill="#EEA774"
      />
      <path
        id="path1008"
        d="M47.2049 125.926C47.326 120.203 47.954 85.8157 48.0754 80.0898C42.9297 76.7182 38.3131 72.8048 34.2793 68.5112"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1012"
        d="M67.3159 68.2511C63.3758 72.5787 58.854 76.5447 53.8008 79.9846C54.0192 85.726 55.2392 120.118 55.4576 125.859"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1016"
        d="M54.5547 75.3047C58.2598 72.5905 61.6435 69.5835 64.6826 66.3538"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1020"
        d="M50.7676 74.8867C52.8019 66.4892 54.2606 57.9997 55.1405 49.4971"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1024"
        d="M47.1474 75.3594C46.1192 71.0631 45.2523 66.7379 44.5488 62.4063"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1028"
        d="M53.9874 86.2786C56.0745 84.3662 58.0062 81.2497 60.0616 80.7201C63.3994 79.86 67.8796 84.1402 70.5846 82.5212C73.7831 80.602 73.8566 73.5089 75.8281 70.787C78.2306 67.4715 81.4972 65.6872 81.4651 61.6499C81.4331 57.6092 78.1385 55.8789 75.6837 52.6005C73.6694 49.9123 73.4836 42.8192 70.2547 40.954C67.5247 39.3721 63.0844 40.1209 59.7334 39.3148C56.7252 38.5862 53.9149 35.2404 50.5801 35.2673C47.2454 35.2943 44.4884 38.6841 41.4923 39.4565C38.1545 40.3199 33.703 39.6419 30.998 41.2643C27.7995 43.1835 27.7259 50.2766 25.7545 52.9985C23.352 56.314 20.0854 58.0949 20.1174 62.1356C20.1495 66.1763 23.4437 67.9066 25.8989 71.1816C27.9128 73.8732 28.099 80.9629 31.3275 82.8315C34.0578 84.41 38.4695 80.059 41.8205 80.8651C43.8884 81.3643 45.8733 84.4606 47.9959 86.3359"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g id="Clip path group_9">
        <mask
          id="mask8_1525_8948"
          maskUnits="userSpaceOnUse"
          x="94"
          y="35"
          width="62"
          height="53"
        >
          <g id="clipPath1036">
            <path
              id="path1034"
              d="M94.9729 62.1372C95.0038 66.1761 98.2803 67.9068 100.722 71.1835C102.724 73.8718 102.908 80.9641 106.119 82.8301C108.834 84.4083 113.224 80.0537 116.557 80.8589C119.55 81.5825 122.366 87.8052 125.684 87.7773C129.001 87.7493 131.723 81.4816 134.703 80.7086C138.024 79.8476 142.479 84.1291 145.171 82.5058C148.353 80.5883 148.429 73.4939 150.39 70.7734C152.781 67.4559 156.031 65.6715 156 61.6326C155.969 57.5937 152.692 55.863 150.252 52.5864C148.25 49.898 148.066 42.8057 144.856 40.9398C142.139 39.3616 137.722 40.1088 134.389 39.3036C131.396 38.5799 128.602 35.2324 125.284 35.2604C121.967 35.2883 119.224 38.6787 116.243 39.4517C112.922 40.3149 108.494 39.6407 105.803 41.264C102.62 43.1815 102.545 50.2759 100.583 52.9965C98.1922 56.3139 94.9422 58.0983 94.9729 62.1372Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask8_1525_8948)">
          <g id="g1032">
            <g id="g1038">
              <path
                id="path1046"
                d="M94.9729 62.1367C95.0036 66.1774 98.2802 67.9077 100.722 71.1828C102.724 73.8709 102.908 80.9641 106.119 82.8293C108.834 84.4078 113.224 80.0534 116.557 80.8595C119.55 81.5847 122.367 87.8042 125.684 87.7773C129.001 87.7503 131.723 81.4835 134.703 80.7077C138.024 79.8477 142.479 84.1312 145.171 82.5055C148.353 80.5897 148.429 73.4932 150.39 70.7746C152.781 67.4557 156.031 65.6715 156 61.6342C155.969 57.5935 152.692 55.8632 150.252 52.5881C148.25 49.9 148.067 42.8068 144.856 40.9416C142.139 39.3631 137.722 40.1086 134.389 39.3024C131.396 38.5807 128.602 35.2314 125.284 35.2617C121.967 35.2887 119.224 38.6784 116.243 39.4508C112.922 40.3143 108.494 39.6397 105.803 41.2654C102.62 43.1812 102.545 50.2778 100.583 52.9963C98.1922 56.3152 94.9421 58.0994 94.9729 62.1367Z"
                fill="#B4DBAD"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Clip path group_10">
        <mask
          id="mask9_1525_8948"
          maskUnits="userSpaceOnUse"
          x="102"
          y="35"
          width="47"
          height="53"
        >
          <g id="clipPath1054">
            <path
              id="path1052"
              d="M102.533 62.0764C102.565 66.1153 106.314 67.8438 108.059 71.1269C109.49 73.8196 109.638 80.9119 111.926 82.7864C113.861 84.371 116.972 80.0293 119.344 80.8431C121.474 81.5754 123.492 87.8044 125.851 87.7851C128.21 87.7658 130.13 81.5066 132.247 80.7422C134.606 79.8898 137.786 84.1821 139.695 82.5652C141.954 80.6563 141.99 73.5619 143.377 70.8456C145.069 67.5367 148.79 65.7502 148.758 61.7092C148.726 57.6702 144.977 55.9439 143.233 52.6608C141.801 49.966 141.653 42.8737 139.366 40.9991C137.431 39.4145 134.291 40.1488 131.919 39.335C129.789 38.6028 127.794 35.2489 125.435 35.2682C123.076 35.2875 121.134 38.6716 119.016 39.4381C116.657 40.2906 113.506 39.6035 111.596 41.2203C109.338 43.1313 109.303 50.2237 107.914 52.9399C106.222 56.2509 102.501 58.0374 102.533 62.0764Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask9_1525_8948)">
          <g id="g1050">
            <g id="g1056">
              <path
                id="path1064"
                d="M102.533 62.0747C102.565 66.1153 106.314 67.8421 108.059 71.1272C109.49 73.8186 109.638 80.9115 111.926 82.7867C113.861 84.3719 116.972 80.0278 119.344 80.844C121.474 81.5759 123.492 87.8053 125.851 87.7851C128.21 87.7649 130.13 81.5051 132.248 80.7428C134.606 79.8895 137.786 84.183 139.695 82.5641C141.954 80.6551 141.99 73.5623 143.377 70.8438C145.069 67.5352 148.791 65.751 148.758 61.7105C148.726 57.6699 144.977 55.9431 143.233 52.6614C141.801 49.9666 141.653 42.8737 139.366 40.9985C137.431 39.4133 134.291 40.1486 131.919 39.3357C129.79 38.6038 127.794 35.248 125.435 35.2682C123.076 35.2885 121.134 38.6713 119.016 39.4369C116.657 40.2902 113.506 39.6022 111.596 41.2211C109.338 43.1301 109.302 50.2229 107.914 52.938C106.223 56.25 102.501 58.0376 102.533 62.0747Z"
                fill="#81A87A"
              />
            </g>
          </g>
        </g>
      </g>
      <path
        id="path1068"
        d="M130.083 49.4957C131 49.6205 131.924 49.7191 132.855 49.7947C132.31 58.3072 131.19 66.8361 129.497 75.3059C133.202 72.5921 136.586 69.586 139.625 66.3564C140.484 67.0037 141.362 67.6344 142.258 68.2488C138.318 72.579 133.797 76.5412 128.743 79.981C128.962 85.7239 130.182 120.116 130.4 125.858C129.347 125.908 127.539 125.944 126.484 125.957L125.807 74.4845C127.79 66.2184 129.217 57.8636 130.083 49.4957Z"
        fill="#8F5409"
      />
      <path
        id="path1072"
        d="M109.223 68.5138C110.11 67.8849 110.978 67.2399 111.826 66.5757C114.915 69.7556 118.345 72.711 122.091 75.3615C121.063 71.0648 120.196 66.7425 119.493 62.4073C120.538 62.2918 121.576 62.1474 122.606 61.9741C123.476 66.2997 124.512 70.6092 125.711 74.8866C125.743 74.755 125.775 74.6203 125.807 74.4855L126.485 125.959C125.291 125.972 123.342 125.965 122.148 125.927C122.269 120.205 122.897 85.816 123.019 80.0914C117.873 76.7188 113.256 72.804 109.223 68.5138Z"
        fill="#EEA774"
      />
      <path
        id="path1076"
        d="M122.148 125.926C122.269 120.203 122.897 85.8157 123.018 80.0898C117.873 76.7182 113.256 72.8048 109.223 68.5112"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1080"
        d="M142.257 68.2511C138.317 72.5787 133.795 76.5447 128.742 79.9846C128.961 85.726 130.181 120.118 130.399 125.859"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1084"
        d="M129.498 75.3047C133.203 72.5905 136.587 69.5835 139.626 66.3538"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1088"
        d="M125.711 74.8867C127.745 66.4892 129.204 57.9997 130.083 49.4971"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1092"
        d="M122.091 75.3594C121.063 71.0631 120.196 66.7379 119.492 62.4063"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1096"
        d="M128.929 86.2786C131.016 84.3662 132.948 81.2497 135.003 80.7201C138.341 79.86 142.82 84.1402 145.526 82.5212C148.725 80.602 148.798 73.5089 150.769 70.787C153.172 67.4715 156.438 65.6872 156.406 61.6499C156.374 57.6092 153.08 55.8789 150.625 52.6005C148.611 49.9123 148.425 42.8192 145.195 40.954C142.466 39.3721 138.025 40.1209 134.675 39.3148C131.667 38.5862 128.856 35.2404 125.522 35.2673C122.187 35.2943 119.43 38.6841 116.434 39.4565C113.096 40.3199 108.644 39.6419 105.939 41.2643C102.741 43.1835 102.667 50.2766 100.696 52.9985C98.2931 56.314 95.0265 58.0949 95.0588 62.1356C95.0909 66.1763 98.3852 67.9066 100.84 71.1816C102.854 73.8732 103.04 80.9629 106.269 82.8315C108.999 84.41 113.411 80.059 116.762 80.8651C118.83 81.3643 120.815 84.4606 122.937 86.3359"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1100"
        d="M62.5426 126.004H18.6309"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="path1104"
        d="M155.368 126.004H68.4121"
        stroke="#392403"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
